/// <amd-module name='Resources/resources'/>
/** This is the list of localized strings for the project */
export const resources = {
    // sampleerror : 'This is some error message' ,
    // anothererror : 'This is another error message'
    ChangeBuildingContextMessage: "Updating the building context can cause extended save times.",
    MapFilterGridMessage: "The Map Filter is on and applied to the List.",
    MoreRowsExist: "More rows exist than this browser can display.",
    Eight11StructureCollisions: "The following 811 fields already exist: <br> {0} <br> Rename conflicting fields and try to authorize again. <br>See the 811 Integration Campus entry for the field name list.",
    Eight11CreateStructure: "The system will be locked for maintenance causing users to be kicked out of the system. After the fields are added, the process continues by performing a reset of OMS and returning the system status to full access.",
    Eight11CreateStructureBypass: "After the fields are added, a reset of OMS is performed.",
    Eight11Confirmation: "Are you sure you want to add 811 fields?",
    Eight11Authorize: "Click Authorize to allow Cartegraph access to 811 emails.",
    Eight11AuthorizeError: "Cannot Authorize",
    RunAnIntegrationStructureCollisions: "The following fields already exist for this integration: <br> {0} <br> Rename conflicting fields and try to authorize again. <br>See the Campus entry for this integration for the field name list.",
    RunAnIntegrationCreateStructure: "The system will be locked for maintenance causing users to be kicked out of the system. After the fields are added, the process continues by performing a reset of OMS and returning the system status to full access.",
    RunAnIntegrationCreateStructureBypass: "After the fields are added, a reset is performed.",
    RunAnIntegrationConfirmation: "Are you sure you want to add fields for this integration?",
    RunAnIntegrationStructureSetup: "Click Setup to allow Cartegraph setup structure for this integration.",
    RunAnIntegrationSettingUpData: "Setting up Initial Data...",
    RunAnIntegrationSetupError: "Cannot Setup",
    RunAnIntegrationSetupNotComplete: "Setup not complete",
    RunAnIntegrationInitialSetup: "Initial Setup",
    RunAnIntegrationInitialSetupFormat: "{0}<br>{1}",
    RunAnIntegrationInitialSetupWasSuccessful: "Initial setup was successful.",
    RunAnIntegrationAdditionalSetupNeeded: "Additional setup is still needed.",
    RESTConnectStructureCollisions: "The following fields already exist for this RESTConnect integration: <br> {0} <br> Rename conflicting fields and try to authorize again. <br>See the Campus entry for this integration for the field name list.",
    RESTConnectCreateStructure: "The system will be locked for maintenance causing users to be kicked out of the system. After the fields are added, the process continues by performing a reset of OMS and returning the system status to full access.",
    RESTConnectCreateStructureBypass: "After the fields are added, a reset is performed.",
    RESTConnectConfirmation: "Are you sure you want to add fields for this integration?",
    RESTConnectStructureSetup: "Click Setup to allow Cartegraph setup structure for this integration.",
    RESTConnectSetupError: "Cannot Setup",
    SearchBuildings: "Search Buildings",
    SearchFloors: "Search Floors",
    SelectBuilding: "Select Building",
    SelectFloor: "Select Floor",
    YesDelete: "Yes, Delete",
    YesContinue: "Yes, Continue",
    ArcGISDefaultUri: "https://www.arcgis.com",
    CopyImpacts: "Copy Impacts",
    ImpactsCopied: "Impacts copied successfully.",
    PasteCopiedImpacts: "Paste Copied Impacts",
    CopyIndexMappings: "Copy Index Mappings",
    IndexMappingsCopied: "Index Mappings copied successfully.",
    PasteCopiedIndexMappings: "Paste Copied Index Mappings",
    ConditionDetail: "Condition Detail",
    ConditionDetails: "Condition Details",
    EditingConditionDetails: "Editing - Condition Details",
    MayTakeFewMinutes: "This could take a few minutes or more.",
    EditAddCriteriaAndRecalculateRiskScores: "{0} criteria and recalculate risk scores?",
    EditCOFCriteriaForAssetTypeWarning: "When editing Consequence of Failure criteria, the risk scores are recalculated for all {0} records, and cannot be undone.",
    AddCOFCriteriaForAssetTypeWarning:
        "When adding Consequence of Failure criteria, the risk scores are cleared for all {0} records. A corresponding field is added to the {0} Detail view, which must be filled out for each {0} asset to recalculate an overall Risk score.",
    OptOutCOFWarningTitle: "Opt Out and Disable CoF Criteria",
    OptInCOFWarningTitle: "Opt In and Enable CoF Criteria",
    OptOutCOFWarningMessage: "Opt out from Consequence of Failure Criteria and enter CoF Score values manually for {0} records?",
    OptInCOFWarningMessage: "Opt in to Consequence of Failure and enable CoF calculations for {0} records? Any existing data in the Consequence of Failure Score field for {0} records will be permanently deleted.",
    OptOutWarningConfirm: "Opt Out",
    OptInWarningConfirm: "Opt In",
    OptOutPOFWarningTitle: "Opt Out and Disable PoF Ranges",
    OptInPOFWarningTitle: "Opt In and Enable PoF Ranges",
    OptOutPOFWarningMessage: "Opt out from Probability of Failure Ranges and enter PoF Score values manually for {0} records?",
    OptInPOFWarningMessage: "Opt in to Probability of Failure and enable PoF calculations for {0} records? Any existing data in the Probability of Failure Score field for {0} records will be permanently deleted.",
    CannotUpdateOptInCOF: "Opt In to CoF value could not be updated. Ask your System Administrator for help.",
    CannotUpdateOptInPOF: "Opt In to PoF value could not be updated. Ask your System Administrator for help.",
    ChangeOrder: "Change Order",
    Edit: "Edit",
    Number: "Number",
    MeasuredValue: "Measured Value",
    EditIndexMappings: "Edit Index Mappings",
    EditImpacts: "Edit Impacts",
    IndexMappings: "Index Mappings",
    Impacts: "Impacts",
    Impact: "Impact",
    CompletedWithErrors: "Completed with Errors",
    FieldMustBeUnique: "The {0} field must be unique.",
    ValueMustBeUnique: "{0} already exists. Enter a unique value.",
    RequiredForThisScenario: "{0} is required for this scenario.",
    ProtocolsCreateWarning: "Protocols are created and edited in Library Manager. ",
    ProtocolsClickHere: "Click here to go to the Protocols Library.",
    EditingSettings: "Editing - Settings",
    CannotAddPlanYear: "Cannot Add Plan Year",
    CannotEditPlanYear: "Cannot Edit Plan Year",
    CannotAddBudget: "Cannot Add Budget",
    CannotEditBudget: "Cannot Edit Budget",
    CannotEditPropertiesTitle: "Cannot Edit Properties",
    CannotDeletePlanYear: "Cannot Delete Plan Year(s)",
    CannotAddProtocol: "Cannot Add Protocol",
    CannotAddProject: "Cannot Add Project",
    CannotEditProject: "Cannot Edit Project",
    CantEditScenario: "The scenario is currently running and cannot be edited.",
    CannotRunScenario: "Cannot Run Scenario",
    CannotEditScenarioTitle: "Cannot Edit Scenario",
    CannotDuplicateScenarioTitle: "Duplicate Scenario Error",
    CannotRemoveProtocol: "Cannot Remove Protocol(s)",
    CannontDisplayChart:
        "Cannot display the Activity Cost per Plan Year data while Scenario {0} is running. Refresh the page when {0} is complete.",
    TooManyPlanYearsOrActivitiesTitle: "Some Data Not Displayed",
    TooManyPlanYearsOrActivities:
        "A maximum of 10 plan years and 12 activities can display on the map. To view all the data, adjust the number of activities or plan years in the scenario.",
    UnlockActivitiesOnProjectsTitle: "Selected Activities Assigned to Projects",
    UnlockActivitiesOnProjectsMessage:
        "Some of the selected activities are assigned to projects. If these activities are unlocked, they are removed from the projects.",
    UnlockActivitiesOnProjectsActivityModeMessage:
        "Some of the selected activities are assigned to projects. If these activities are changed to No Activity, changed to a new plan year, or unlocked, they are removed from the projects.",
    UnlockActivitiesOnProjectsButton: "Unlock and Apply",
    ChangeActivitiesOnProjectMessage:
        "Some of the selected activities are assigned to projects. If these activities are changed to a new activity or plan year they are removed from the projects.",
    ProjectCreated: "Project Created",
    ProjectUpdated: "Project Updated",
    ProjectDeleted: "Project Deleted",
    NoPlanYears: "No plan years to display",
    Legend: "Legend", // As in a map legend, not folklore or urban legend.
    DidntFindAnyProjects: "We didn't find any projects.",
    ProjectAlreadyConvertedToWork: "This project was already converted to Work.",
    ChartNoDataActivityMode:
        "No data to display because there are no recommendations for the {0} activity in the first 10 years of the scenario.",
    ChartNoDataPlanYearMode:
        "No data to display because there are no recommendations for the plan year.",
    ChartNoDataPlanYearModeFilterPane:
        "No data to display because there are no recommendations for the selected projects.",
    DomainSubtype: "Domain/Subtype",
    DomainSubtypeField: "Domain/Subtype Field",
    DataValue: "Data Value",
    Synchronize: "Run Sync Now",
    TestFailed: "Test Failed",
    OnBeforeUnloadBrowserMessage: "Unsaved changes will be lost.",
    ValidationReservedWords: "The {0} field cannot be a reserved word.",
    ValidationStartWithcg: "{0} cannot start with the letters cg.",
    ValidationContains_Unit: "{0} cannot contain _unit.",
    ValidationStartWithsys: "{0} cannot start with the letters sys.",
    ValidationStartWithNum: "{0} cannot start with a number.",
    ValidationStartWithUnderscore: "{0} cannot start with a underscore.",
    ValidationContainsSpaces: "{0} cannot contain spaces.",
    ValidationSpecialCharacters: "The {0} field cannot contain special characters.",
    ValidationRequired: "The {0} field requires a value.",
    ValidationRequiredSimple: "This field requires a value.",
    ValidationMaxLength: "This field cannot have more than {0} characters.",
    ValidationDate: "Invalid date format. Use the {0} format.",
    ValidationTime: "Invalid time format. Use the h:mm:ss tt format.",
    ValidationDateTime: "Invalid date and time format. Use the {0} format.",
    ValidationNumberRange: "{0} must be greater than or equal to {1} and no more than {2}.",
    ValidationFieldSize: "The length of Prefix + Number + Suffix exceeds the field size.",
    ValidationDefaultSize: "The Field Default can not exceed 50 characters.",
    ValidationTextRequired:
        "The Field Validation Text is required when Validation Rule is entered.",
    ValidationAssociatedPrimaryGroupRequired: "The Associated Primary Group is required.",
    ValidationNumberRangeGreaterThanAndLessThanOrEqualTo:
        "{0} must be greater than {1} and no more than {2}.",
    ValidationRangeGreaterThanOtherField: "{0} must be greater than {1}.",
    ValidationSampleRange: "Distress size is larger than the Samples size.",
    ValidationFieldIsNowRequiredWarning:
        "The {0} field's Required property was changed. Existing records may not contain data for this field. Data entry may be necessary to correct any errors caused by this change.",
    ValidationFieldNewFieldRequiredWarning:
        "Existing records may not contain data for this new field. Data entry may be necessary to correct any errors caused by this change.",
    ValidationFieldIsUniqueAndRequiredError:
        "Marking the {0} field as Unique and Required is not allowed. Changes to the Unique and Required properties will be removed.",
    ValidationFieldTruncationError: "The Maximum Characters value cannot be less than {0}.",
    ContinueEditing: "Continue Editing",
    ContinueWithInstall: "Continue With Install",
    DiscardChanges: "Discard Changes",
    AutoNumber: "Auto Number",
    Asset: "Asset",
    AddingSomething: "Adding {0}",
    EditingSomething: "Editing {0}",
    UpdatingSomething: "Updating {0}",
    CreatingSomething: "Creating {0}",
    CreatingTask: "Creating Task",
    CreatingField: "Creating Field",
    Creating: "Creating",
    NonAssetTask: "Non-Asset Task",
    NonAssetSingularName: "Non-Asset",
    NonAssetClass: "NonAsset",
    AssetTask: "Asset Task",
    CreatingWorkOrder: "Creating Work Order",
    CreatingAssociation: "Creating Association",
    EditingAssociation: "Editing - Association: {0}",
    ViewAssociation: "Association: {0}",
    Association: "Association",
    Spatial: "Spatial",
    StartInspection: "Start Inspection",
    EditInspection: "Edit Inspection",
    ViewInspection: "View Inspection",
    CannotCalculateIndexMissingConditionData:
        "Cannot calculate the index because there is missing condition data.",
    CannotCalculateIndexNoMappings:
        "Cannot calculate the index because there are no index mappings.",
    FourOhFourString:
        "Page not found. Make sure you entered or copied the URL correctly.<br/>If the problem continues, ask your System Administrator for help.",
    StatusCompleted: "COMPLETED",
    StatusCanceled: "CANCELED",
    WOHasOpenTasks:
        "This Work Order has Tasks with a status of Planned or In Progress and cannot be marked Completed or Canceled.",
    SomeFieldsHaveErrors: "Some Fields Have Errors",
    CannotDeleteResourceLogEntries: "Cannot Delete Resource Log Entries",
    CorrectErrorsWithDelete:
        "Correct the errors to continue. The System Administrator prevented you from deleting Resource Log entries. The deleted entries will remain in the Resource Logs. Ask the System Administrator for help with access.",
    UnableToDeleteResourceLogEntries:
        "The System Administrator prevented you from deleting Resource Log entries. The deleted entries will remain in the Resource Logs. Ask the System Administrator for help with access.",
    WaitIndicator: "Loading...",
    Saving: "Saving...",
    LoadingMap: "Loading Map...",
    PercentSaved: "{0}% saved",
    Finalizing: "Finalizing...",
    AboutToCreateTasks: "You are about to create {0} tasks.",
    ContinueCreatingTasks:
        "This could take a few minutes or more. Do you want to continue creating these tasks?",
    CreateTasksNow: "Create tasks now",
    PrintMap: "Print Map",
    Title: "Title",
    Print: "Print",
    Landscape: "Landscape",
    Portrait: "Portrait",
    EnterPrintoutTitle: "Enter printout title",
    DistributingResources: "Distributing Resources...",
    DistributingResourcesTitle: "Distributing Resources Complete",
    DistributingResourcesSuccessText: "The Resources were successfully distributed to {0} tasks.",
    ProcessStillRunning: "Time Sheet Process<br/>Already Running...",
    ProcessSaveErrorTitle: "Cannot Save Time Sheet",
    ProcessStillRunningText:
        "Another time sheet process is running. Wait for it to finish and try again",
    ProcessBeingSaved: "Another time sheet is being saved. Try again later.",
    ProcessHasErrors: "Correct the following errors and try again:<br/>{0}",
    SearchByAddress: "Search by address",
    AddLocation: "Add Location",
    LocationPermissionsDenied: "Location permissions denied",
    SelectAssetType: "Select Asset Type",
    KeepAssetType: "Keep Asset Type",
    ChangeAssetType: "Change Asset Type",
    KeepAssociation: "Keep Association",
    DiscardAssociation: "Discard Association",
    ChangeAssetTypeDialogTitle: "Are you sure you want to change the Asset Type?",
    ChangeAssetTypeDialog:
        "You currently have assets selected. Changing the Asset Type will remove all assets from the selection.",
    ChangeAssetTypeDialogAddLocation:
        "You currently have a location selected. Changing the Asset Type will remove the location selected.",
    CancelChangeDialogTitle: "Are you sure you want to cancel?",
    CancelChangeDialog: "Unsaved changes will be lost.",
    ScenarioCancelDialog: "All scenario results will be lost.",
    ContinueRunning: "Continue Running",
    DiscardScenarioResults: "Discard Scenario Results",
    MaxCharsChangeDialogTitle: "Are you sure you want to make this change?",
    MaxCharsChangeDialog:
        "The Maximum Characters field was changed from {0} to {1} characters.  Data in existing records might be lost or cut off.",
    InvalidSelection: "Invalid Selection",
    CannotASelectMoreThan: "More than {0} records are in the list. Filter the list to {0} or less.",
    CannotCreateFutureEntries: "Cannot create future entries.",
    CannotAssociate: "Cannot Associate",
    ResourceDateCannotBeAfter: "Resource date cannot be after {0}.",
    GpsFailure: "Cannot locate current position.",
    ClearLocationDialogTitle: "Are you sure you want to remove the location?",
    ClearLocationDialog: "The record will not display on the map.",
    ClearLocationDialogGis: " The matching feature will also be deleted from GIS.",
    KeepLocation: "Keep Location",
    RemoveLocation: "Remove Location",
    Location: "Location",
    TrySaveShapeOrCancel: "Try saving again, or Cancel",
    EditPointInstructions: "Click on a location to move the pin.",
    EditLineOrPolyInstructions: "Drag the handles to change the shape.",
    UseGISToEditLocation: "You must use GIS to edit a multi-part location.",
    UseGISToEditZAndM: "You must use GIS to edit an M-aware or Z-aware location.",
    UseGISToEditGeometry: "You must use GIS to edit a {0} location.",
    GISIntegration: "GIS Integration",
    SystemError: "System Error",
    CannotProcessCommand: "Cannot process command. Ask your System Administrator for help.",
    SaveError: "Save Error",
    CannotSaveError: "Cannot Save",
    CannotDisplaySummaryDialog: "Cannot Display Summary. Ask your System Administrator for help.",
    FindALibrary: "Find a Library",
    FindARole: "Find a Role",
    CannotCreateTask: "Cannot Create Task",
    CannotCreateRecord: "Cannot Create {0}",
    CannotDuplicateRecord: "Cannot Duplicate {0}",
    ClearFilterDialogTitle: "Are you sure you want to clear the filter?",
    ClearFilterDialog: "The filter will be lost if you continue.",
    Filter: "Filter",
    ReopenInspectionTitle: "Inspection is Complete",
    ReopenInspectionDialog:
        "If you edit a completed inspection, the inspection calculations are removed. Be sure to complete the inspection after editing to update the calculations.",
    CannotContinuePCIInspection: "Cannot Continue with PCI Inspection",
    Incremental: "Incremental",
    InspectionMissingRequiredInfo: "The inspection is missing required information:",
    InspectionType: "Inspection type",
    PavementLength: "Pavement length",
    PavementWidth: "Pavement width",
    PavementCannotAddSample: "Cannot Add Sample",
    PavementLengthTooLong:
        "Pavement length is longer than the maximum of {0} to use the US Army Corps of Engineers Sampling Method.",
    PavementWidthTooLong:
        "Pavement width is longer than the maximum of {0) to use the US Army Corps of Engineers Sampling Method.",
    PavementSampleToLessThanFrom: "The From value must be less than the To value.",
    PavementSampleFromEmpty: "The From field is required.",
    PavementSampleToEmpty: "The To field is required.",
    PavementSampleFromGreaterThanZero: "The From value cannot be less than zero.",
    PavementCannotAddDistress: "Cannot Add Distress",
    PavementCannotDeleteDistress: "Cannot Delete Distress",
    PavementDistressAreaOrLengthExceedsSample:
        "There is an existing {0} distress with a {1} severity with an extent of {2}%. The combined extent must be no more than 100%.",
    Random: "Random",
    EditPCIInspection: "Edit PCI Inspection",
    StartPCIInspection: "Start PCI Inspection",
    MeasurementTypeArea: "Sq Feet:",
    MeasurementTypeLinear: "Linear Feet:",
    LinearMeters: "Linear Meters:",
    SquareMeters: "Sq Meters:",
    ClearFilterTitle: "Are you sure you want to clear the filter?",
    ClearFilterMessage: "The filter will be lost if you continue.",
    KeepFilter: "Keep Filter",
    ClearFilter: "Clear Filter",
    LengthLower: "length",
    AreaLower: "area",
    FeetAbbreviated: "ft",
    Squared: "²",
    UploadInProgressTitle: "Upload In Progress",
    UploadInProgressMessage: "Cannot complete action while an upload is in progress.",
    RemoveRepeatingWOTitle: "Are you sure you want to remove?",
    RemoveRepeatingWOMessage: "The Repeating Schedule will be removed from the Work Order.",
    RemoveMultipleRepeatingWOMessage:
        "The Repeating Schedule will be removed from the Work Orders.",
    KeepSchedule: "Keep Schedule",
    RemoveSchedule: "Remove Schedule",
    RemoveFromScenario: "Remove from Scenario",
    PleaseWait: "Please Wait...",
    ResttingOms: "Resetting OMS...",
    Processing: "Processing...",
    Exporting: "Exporting...",
    Deleting: "Deleting...",
    Removing: "Removing...",
    Selecting: "Selecting...",
    Canceling: "Canceling...",
    RemovingTasks: "Removing Tasks...",
    Installing: "Installing...",
    RemovingRepeatingSchedules: "Removing Repeating Schedules...",
    CalculatingPCIIndex: "Calculating PCI Index...",
    GeneratingSamples: "Generating Samples...",
    ProcessingSelectAll: "Processing Select All...",
    ProcessingClearAll: "Processing Clear All...",
    Validating: "Validating...",
    Error: "Error",
    ServerError: "Server Error",
    AccessDenied: "Access Denied",
    ResetOmsFailed: "Reset OMS Failed",
    CantDeleteTitle: "Cannot Delete {0}",
    CannotLeavePage: "Cannot Leave Page",
    StructureManagerIntro:
        "You are about to make structural changes to the system. Make sure of the following: <br/>- Lock the system by going to Set System Access<br />- No background tasks are running. <br />- No users are signed in. <br />- No integrations are running. <br />",
    StructureManagerIntroTitle: "Before Making Structure Changes",
    AssetAdministrationWarningTitle: "Before Installing Assets",
    UploadFailed: "Upload Failed",
    SavingLayout: "Saving Layout",
    LoadingLayout: "Loading Layout",
    InvalidLayout: "Invalid Layout",
    CannotAddGridToOverviewHeader: "Grids cannot be added to an Overview layout.",
    InvalidViewName: "Invalid View Name",
    InvalidStatementInFilter: "Invalid Statement in Filter",
    DefineInternalRequestView: "Define Internal Request View",
    ReqestIssue: "Request Issue: ",
    DuplicateItem: "Duplicate Item",
    DuplicateViewName: "Duplicate View Name",
    DuplicateSectionName: "Duplicate Section Name",
    DuplicateGroupHeaderTitle: "Duplicate Group Header Title",
    FilterContainsInvalidValue: "Filter Contains An Invalid Value",
    ContinueTasksNotAssociatedToAnother: "{0} Continue with Tasks not associated to another {1}?",
    RunReport: "Run Report",
    LaunchWebDesigner: "Open Advanced Designer",
    LaunchWebDesignerTitle: "Are you sure you want to edit with the Advanced Designer?",
    LaunchWebDesignerMessage:
        "This report was last edited with the Basic Designer. Once you edit with the Advanced Designer, reports cannot be edited using the Basic Designer.",
    ReportSelectionLimitMessage:
        "More than the maximum number of records for a report are selected. Change the number of selected records to {0} or less to continue.",
    ReportNameReportView: "Report Name – Reports Page",
    ReportNameDetailView: "Report Name – Detail View",
    CannotRunReport: "Cannot Run Report",
    CannotUpdateTask: "Cannot Update Task",
    CannotAddTask: "Cannot Add Task",
    CannotAddTasks: "Cannot Add Tasks",
    CannotAddResource: "Cannot Add Resource",
    CannotChangePassword: "Cannot Change Password",
    CannotCompleteTask: "Cannot Complete Task",
    CannotCompleteWorkOrder: "Cannot Complete Work Order",
    CannotDisplaySummary: "Cannot Display Summary",
    CannotCloseRequest: "Cannot Close Request",
    CannotAddRequester: "Cannot Add Requester",
    CannotGetInspection: "Cannot Get Inspection",
    CannotLoadRequester: "Cannot load Requester",
    CannotRemoveRequester: "Cannot Remove Requester",
    CannotEditTaskAssignments: "Cannot Edit Task Assignments",
    CannotDeleteSelectedRecord: "Cannot Delete Selected Record",
    CannotDeleteSelectedRecords: "Cannot Delete Selected Records",
    CannotSetPrimaryAttachedFile: "Cannot Set Primary Attached File",
    CannotActivateFilterTryAgain: "Cannot activate the filter. Try again later.",
    CannotResetUserPersistenceSelected: "Cannot Reset User Persistence for Selected User",
    CannotResetUsersPersistenceSelected: "Cannot Reset User Persistence for Selected Users",
    ResetPasswordFailed: "Reset Password Failed",
    AskYourSystemAdminForHelpPeriod: "Ask your System Administrator for help.",
    AreYouSureGeneric: "Are you sure you want to ",
    DeleteDialogTitle: "Are you sure you want to delete?",
    FinishDialogTitle: "Are you sure you want to finish?",
    RemoveDialogTitle: "Are you sure you want to remove?",
    AreYouSureMakeAssociation: "Are you sure you want to make this association?",
    UndoDialogTitle: "Are you sure you want to undo?",
    ClearAllDialogTitle: "Are you sure you want to clear all?",
    AreYouSureMakeChange: "Are you sure you want to make this change?",
    LeavePageDialogTitle: "Are you sure you want to leave the page?",
    LeaveViewDialogTitle: "Are you sure you want to leave the view?",
    ResetViewDialogTitle: "Are you sure you want to reset the view?",
    DeleteViewDialogTitle: "Are you sure you want to delete the view?",
    DeleteReportDialogTitle: "Are you sure you want to delete the report?",
    RemoveRequesterDialogTitle: "Are you sure you want to remove the Requester?",
    RequesterWillBeRemovedDialog: "Requester will be removed from the selected request.",
    ResetUserPersistenceDialogTitle: "Are you sure you want to reset user persistence?",
    ClearLayoutDialogTitle: "Are you sure you want to clear the layout?",
    DeleteScriptDialogTitle: "Are you sure you want to delete script {0}?",
    CreatingFormatFileDialogTitle: "Creating Format File",
    DeleteFormatFileDialogTitle: "Are you sure you want to delete the format file?",
    CorrectErrorsToContinue: "Correct the errors to continue.",
    CorrectXErrorsToContinue: "Correct {0} errors to continue.",
    FilesNotUploadedLostDialog: "Files not uploaded will be lost.",
    CurrentLayoutRemovedDialog: "The current layout will be removed.",
    ViewReturnedtoDefaultDialog: "View will be returned to the default state.",
    ViewDeletedfromSystemDialog: "View will be deleted from the system.",
    ReportDeletedfromSystem: "Report will be deleted from the system.",
    NoLoadSecuritySettings: "Could not load Security Settings.",
    NoSaveSecuritySettings: "Could not save Security Settings.",
    CannotUndoWarning:
        "The {0} {1} was marked {2}. This setting cannot be adjusted once the change is saved.",
    NoPermissionViewPage: "You do not have permission to view this page.",
    EnteredInvalidFilter: "You entered an invalid filter.",
    CannotCalculateIndex: "Cannot Calculate Index",
    ConditionCategory: "Condition Category",
    ConditionCategories: "Condition Categories",
    Risk: "Risk",
    RiskSettings: "Risk Settings",
    RiskStatusRanges: "Risk Status Ranges",
    ConsequenceOfFailureSettings: "Consequence of Failure Settings",
    ConsequenceOfFailureCriteria: "Consequence of Failure Criteria",
    ProbabilityOfFailureSettings: "Probability of Failure Settings",
    ProbabilityOfFailureConversionRanges: "Probability of Failure Conversion Ranges",
    UneditableInStructureManagerError: "{0} properties cannot be edited because the field is locked for data integrity.",
    UneditableInStructureManagerCOFError: "{0} is a system field for Consequence of Failure and can only be edited in Asset Condition Manager.",
    EstimatedIndexValueMissing:
        "Estimated Index was not calculated for one or more condition categories marked Not Inspected. If you want an Index for a condition category, ask your System Administrator to make sure the prerequisite data is in place.",
    CannotCompleteInspection: "Cannot Complete Inspection",
    AttachmentsNotFound: "Attachments Not Found",
    NoRemoveRequester: "Could not Remove Requester",
    NoAddRequester: "Could not Add Requester",
    NoLoadRequester: "Could not load Requester",
    NoLoadRoleAdmin: "Could not load Role Administration",
    PromptsInSyntaxViewNotAllowedRemoveFilter:
        "Prompts in Syntax View are not allowed. Remove filter prompt to continue.",
    NoRecordsSelectedLeastOneMustBe:
        "No records are selected. At least one record must be selected to continue.",
    TooManyRecordsToReportFilterLess2000:
        "There are too many records to report. Filter your records to less than 2000.",
    FileNotUploadedAskAdmin: "File could not be uploaded. Ask your System Administrator for help.",
    EditSchedule: "Edit Schedule",
    EditRepeatingScheduleTitle: "Are you sure you want to edit repeating schedules?",
    EditRepeatingScheduleMessage:
        "The selected Work Orders have repeating schedules. Continuing to edit will replace any existing repeating schedules.",
    Update: "Update",
    UpdatingRecords: "Updating Records",
    StayOnPage: "Stay on Page",
    LeaveWithoutSaving: "Leave Without Saving",
    LeaveWithoutOrdering: "Leave Without Ordering",
    RevertDialogTitle: "Are you sure you want to revert?",
    ConfirmDelete: "Confirm Delete",
    FileNoLongerExists: "This file was renamed or no longer exists. The browser tab will close.",
    RequestClosedSetRequestStatusOpen:
        "Request {0} is Closed. Set the Request’s Status to Open to create a Task.",
    AlreadyExistsViewNamed: "View name {0} already exists.",
    CannotUseViewNameEnterDifferent: "Cannot use {0} as a view name. Enter a different name.",
    CannotSaveView: "Cannot Save View",
    LenghtofViewNameGreater:
        "View name is more than 30 characters. Make the view name shorter to continue.",
    CannotAddedSection: "{0} cannot be added to the {1} section.",
    ReadOnlyFieldsCannotAddedSection: "Read-only fields cannot be added to the {0} section.",
    CannotFindAttachmentsForAskAdmin:
        "Cannot find attachments for {0}. Ask your System Administrator for help.",
    CannotBeInLaytoutMoreThanOnce: "{0} cannot be in the layout more than once.",
    CannotBeInSectionMoreThanOnce: "{0} cannot be in a section more than once.",
    CannotBeInFormatFileMorThanOnce: "{0} cannot be in the format file more than once.",
    RecordCannotBeFoundAskAdmin: "Record cannot be found. Ask your System Administrator for help.",
    CannotAddNewRowAskAdmin: "Cannot add new row. Ask your System Administrator for help.",
    CannotLoadResourceEntryAskAdmin:
        "Cannot load resource entry. Ask your System Administrator for help.",
    CannotRemoveSelectedTaskFrom: "Cannot remove selected Tasks from {0}",
    CannotRemoveSelected: "Cannot remove selected {0}",
    AllResourceRowsRemovedDialog: "All resource rows will be removed.",
    AddRequesterToDifferentRequest: "Add Requester to different request.",
    RequesterRemovedFromRequestAddedRequest:
        "The requester will be removed from Request {0} and added to Request {1}.",
    RequesterAddedToPreviousRequest: "The Requester is added to a previous request.",
    ChangingWillRemoveRequesterFromPreviousRequest:
        "Changing the issue will remove the Requester from the previous request.",
    NoColumnsSelected: "No columns selected.",
    LeastOneColumnBeSelectedDialog: "At least one column must be selected.",
    ToManyRecordsInListFilterToLess:
        "More than {0} records are in the list. Filter the list to {0} or less.",
    NoLocationSelectedForRecord: "No Location was selected for the record.",
    NoLocationNoAddress: "Cannot locate the address. No results found.",
    ClickClearLocationDrawRecordOnMapDialog:
        "Click Clear Location to continue without a location. Draw the record on the map to continue.",
    ClickClearLocationDrawRecordOnMapDialogEdit:
        "Click Clear Location to save without a location. Draw the record on the map and click Save to save with a location.",
    PluralNameRenameTitle: "{0} Recordset Renamed {1}",
    PluralNameRenameHeader: "The following Project Home {0} cannot be renamed.<br/><br/>",
    PluralNameRenameFooter:
        "<br/>Use Windows tools to rename the {0} and keep them synchronized with {1} recordset.",
    InvalidLookupTargetTitle: "Cannot Create Lookup Association",
    InvalidLookupTargetError:
        "Select a library or recordset with a field marked both Unique and Required.",
    ComponentSnapshot: "Component Snapshot",
    Directory: "directory",
    Directories: "directories",
    Create: "Create",
    Delete: "Delete",
    Duplicate: "Duplicate",
    Actions: "Actions",
    LockForMaintenance: "Lock for Maintenance",
    OK: "OK",
    All: "All",
    Add: "Add",
    Save: "Save",
    Done: "Done",
    Close: "Close",
    Continue: "Continue",
    UndoChanges: "Undo Changes",
    SaveChanges: "Save Change",
    CancelDelete: "Cancel Delete",
    ContinueToDelete: "Continue to Delete",
    ContinueToApply: "Continue to Apply",
    KeepUserPersistence: "Keep User Persistence",
    ResetUserPersistence: "Reset User Persistence",
    KeepCurrentLink: "Keep Current Link",
    Large: "Large",
    LinkToSelectedAsset: "Link to Selected Asset",
    LinkToThisAsset: "Link to This Asset",
    KeepWithInsert: "Keep {0}",
    RemoveWithInsert: "Remove {0}",
    KeepIssue: "Keep Issue",
    ChangeIssue: "Change Issue",
    KeepView: "Keep View",
    DeleteView: "Delete View",
    ResetView: "Reset View",
    StayOnView: "Stay on View",
    KeepReport: "Keep Report",
    KeepFile: "Keep File",
    DeleteFile: "Delete File",
    KeepLayout: "Keep Layout",
    DiscardLayout: "Discard Layout",
    DeleteScript: "Delete Script",
    CannotAddTheServer: "Cannot Add the Server",
    KeepRows: "Keep Rows",
    ClearAllRows: "Clear All Rows",
    KeepRequester: "Keep Requester",
    RemoveRequester: "Remove Requester",
    Requesters: "Requesters",
    SendEmailToRequesters: "Send Email To Requesters",
    SendEmailToAssignments: "Send Email To Assignments",
    EmailAddresses: "Email Addresses (separate by semicolons)",
    RecordSourceForEmail: "Record Source for Email",
    InvalidRecordSourceForReportEmail: "Child or library records not allowed for the Send Email with Report block.\n\nUse the Send Email block for these recordsets.",
    EmailField: "Email Field",
    Syntax: "Syntax",
    CopyErrorMessage: "Copy error message details",
    CopyWebhookURL: "Copy webhook URL to clipboard.",
    CopiedToClipboard: "Copied to clipboard.",
    Assignments: "Assignments",
    AssignmentsSaved: "Labor Assignments Saved",
    KeepWithCurrentRequest: "Keep with Current Request",
    Medium: "Medium",
    MoveToDifferentRequest: "Move to Different Request",
    UserName: "User Name",
    Password: "Password",
    NewPassword: "New Password",
    ConfirmPassword: "Confirm Password",
    ValueRequired: "Value Required",
    UniqueValuesRequired: "Unique Values Required",
    AutoNumberBrackets: "[Auto-number]",
    AutoNumberParenthesis: "(AutoNumber)",
    Small: "Small",
    SelectAsset: "Select Asset",
    SelectLabor: "Select Labor",
    EnterPrompt: "Enter Prompt",
    NewScriptName: "New Script Name",
    FindAReport: "Find a Report",
    Task: "Task",
    Tasks: "Tasks",
    TaskVariableBeRemovedFromCurrenetRecord: "{0} {1} will be removed from the current {2}.",
    ClicktoDrawDoubleClickToFinish: "Click to draw the {0}, double-click to finish.",
    EnterSyntaxViewDialogTitle: "Are you sure you want to enter Syntax View?",
    EnterSyntaxViewDialog:
        "Warning: You are entering Syntax View. You may lose your Advanced Filter if you continue.",
    AdvancedFilter: "Advanced Filter",
    Section: "Section",
    Group: "Group",
    Column: "Column",
    Ungroup: "Ungroup",
    ReadOnly: "Read-only",
    DiscardSpaceInsert: "Discard {0}",
    KeepSpaceInsert: "Keep {0}",
    RemoveItemDialogTitle: "Are you sure you want to remove the {0}?",
    RemoveItemFromViewDialog: "{0} will be removed from the view.",
    UsersPossessive: "Users'",
    UserPossessive: "User's",
    SignRetroreflectivityFailedDialogTitle: "Sign Retroreflectivity Failed",
    SignRetroreflectivityFailedDialog:
        "The retroreflectivity readings for Sign {0} are below the minimum acceptable conditions. Repair or replacement is needed.",
    ResetUserPersistenceDialog: "{0} {1} persistence will be reset.",
    TaskBeChangedToCorrectPrecesionLossByRounding:
        "Task {0}'s {1} will be changed to {2} to correct precision loss caused by rounding.",
    TaskWillBeRoundedTo: "Task {0}'s {1} will be rounded to {2}",
    ThereWasXError: "There was a {0} error.<br/>{1}",
    NoDataDisplaySelDateRange: "No data to display. Select another date range.",
    NoDataToDisplay: "No data to display.",
    EditingWithHyphen: "Editing - {0}",
    Editing: "Editing",
    ProcessingNoEllipsis: "Processing",
    NotInspected: "Not Inspected",
    NotTested: "Not Tested",
    SelectField: "Select Field",
    SelectOperator: "Select Operator",
    SelectRecipient: "Select Recipient",
    SelectGeodatabaseAttribute: "Select Geodatabase Attribute",
    Activate: "Activate",
    Apply: "Apply",
    Cancel: "Cancel",
    AssessmentsLoading: "Verifying Assessments...",
    XAssessmentTasks: "{0} Assessment Tasks",
    OneAssessmentTask: "1 {0} Assessment Task",
    AssessmentTaskRequirements:
    `To create a task, the assessment:
    &nbsp&nbsp&nbsp&nbspMust have an Asset ID and Asset Type.
    &nbsp&nbsp&nbsp&nbspCannot be associated with an existing Task ID.
    &nbsp&nbsp&nbsp&nbspCannot have status Work Completed or Inactive.
    &nbsp&nbsp&nbsp&nbspPlease check the CSV log file for details. `,
    AssessmentActivityMustBeSameError: "All selected Assessments must have the same Activity and the Activity field cannot be empty.",
    NoAssessmentEligibleTaskErrorTitle: "Cannot Create Tasks",
    NotAllAssessmentEligibleTaskErrorTitle: "Cannot Create Tasks for All Selected Assessments",
    AssessmentEligibleCount: "{0} assessments meet the requirements.<br/>",
    AssessmentIgnoredCount: "{0} assessments do not meet the requirements.<br/>",
    ContinueWithEligibleAssessments: "Create tasks for {0} assessments?",
    XAssetTask: "{0} Asset Task",
    XAssetTasks: "{0} Asset Tasks",
    XXTasks: "{0} {1} Tasks",
    XXTask: "{0} {1} Task",
    UnlinkAsset: "Unlink Asset",
    LinkAsset: "Link Asset",
    AddField: "Add Field",
    NameColon: "Name:",
    View: "View",
    Date: "Date:",
    EndDate: "End Date:",
    ThroughDate: "Through Date:",
    BeginDate: "Begin Date:",
    FromDate: "From Date:",
    PrimaryAttachment: "Primary Attachment",
    DeleteAttachedFile: "Delete Attached File",
    SelectionMustBePolygon: "Selection must be a Polygon.",
    SelectionLinesNoCross: "Selection lines cannot cross.",
    NoFilterAllRequests: "No Filter - All Requests",
    LinkToXBeRemoved: "The link to {0} will be removed from the system.",
    FieldPermanentlyRemovedSystem: "The {0} field will be permanently removed from the system.",
    RecordSetPermanentlyRemovedSystem:
        "The {0} recordset will be permanently removed from the system.",
    RelationshipRemovedSystem:
        "The {0} relationship to {1} will be permanently removed from the system.",
    LibraryNameError: "Invalid Library Name",
    BePermanentlyRemovedSystem: "{0} will be permanently removed from the system.",
    FormatFileDeletedSystem: "Format file will be deleted from the system.",
    DateCannotBeforeX: "Date cannot be before {1}.",
    DateCannotAfterX: "Date cannot be after {1}.",
    DateCannotBeInFuture: "Date cannot be in the future.",
    DateCannotBeInPast: "{0} cannot be in the past.",
    PasswordsNoMatch: "The passwords do not match.",
    Value: "Value",
    ValueMustBeGreaterThan0: "Value must be greater than 0.",
    ValueMustBeGreaterThanOrEqualTo0: "{0} must be greater than or equal to 0.",
    ValueCannotBeNeg: "Value cannot be a negative number.",
    EntriesCannotBeNegOrMore24Hrs: "Entries cannot be negative numbers or more than 24 hours.",
    ValueMustBeLessEveryXX: "Value must be less than Every {0} {1}",
    ActualStartDateOnBefore: "The Actual Start Date must be on or before {0}.",
    ActualStopDateOnAfter: "The Actual Stop Date must be on or after {0}.",
    NoRecordsDisplay: "No records to display",
    NoAssociationsDisplay: "No associations to display",
    CannotMakeActive: "Cannot Make Active",
    DuplicateFeatureClassLayer:
        "This association must stay Inactive because there is an active GIS Association to the {0} Feature Class Layer. To make this GIS Association active, first mark the other GIS Assocation Inactive.",
    NoViewOrScriptLoaded: "No view or script loaded",
    ScriptsApplyDetailEditViewOnly: "Scripts apply to Detail/Edit view types only.",
    ViewNoScriptSelFromBoxCreate:
        "View has no script defined. Select <New> from the combobox to create it.",
    OneXTask: "1 {0} Task",
    SectionX: "Section {0}",
    InactiveAssociationWillNotBeSynchronized:
        "The Association will not be synchronized because it is set as Inactive.",
    TheLineItemWillBeRemovedFromTheCurrentOrderProcess:
        "The Line Item will be removed from the current Order Process.",
    CannotSynchronizeAssociation: "Cannot Synchronize Association",
    EnablingDebugMode: "Enabling debug mode",
    DebugMode: "Debug mode",
    MapWasNotSavedAsSecured:
        "Map {0} was not saved as secured. Cartegraph requires maps to be secured running under https. Ask your GIS Administrator for help.",
    ListStale:
        "The records in the list changed causing the list to be stale. Click OK to refresh the page and try again.",
    SomeRecordsNotDisplayedOnMap:
        "Some records are not displayed on the map.<br/>Zoom in or adjust your filter.",
    MapWasRemovedFromArcGIS: "Map {0}  was removed from ArcGIS. Use a different map.",
    MapIsNotAvaliable:
        "The map is not available. Try again later or ask your GIS Administrator for help.",
    FatalErrorLoadingMap:
        "There was a problem loading the map. Try again later or ask your GIS Administrator for help.",
    TheAmountPulledCannotExceedTheAmountAvailable: "Transfer Qty exceeds the From Qty Avail amount.",
    Layout: "Layout",
    LayerSaved: "Layer Saved",
    DeleteLayer: "Delete Layer",
    ErrorSearchingLayers: "Error Searching Layers",
    MarkAsFavorite: "Mark as Favorite",
    RemoveFromFavorites: "Remove from Favorites",
    DeleteProjectMessage:
        "The project is removed from the scenario. If the project has already been converted to a work order, the work order and associated tasks are not deleted.",
    ProjectConvertedAssignError:
        "Project {0} was converted to work.  Converted projects cannot be edited.",
    ProjectConvertedError:
        "One or more of the selected records belong to a converted project and a task exists for these records.  Converted projects cannot be edited.",
    SystemLockedForMaintenanceDefault:
        "The system will be locked for maintenance. Please save your work and sign out of the system. - System Administrator",
    VectorLayersNotSupportedForPrinting:
        "The {0} map contains vector tile layers and cannot be printed. Select a different web map before printing.",
    SaveLayerAlreadyExists:
        "You already have a saved layer with this name. You can either update it or rename it to save it as a new layer.",
    OnlyL2UsersCanPerformAction:
        "Only users with editing permissions can {0} Associations using ArcGIS Online or Portal servers.",
    TimeoutOccurredRetrievingPrintout:
        "A timeout occurred while trying to retrieve the printout from ArcGIS.",
    ErrorOccurredRetrievingSpatialAnalysis:
        "An error occurred while trying to retrieve the spatial analysis results from ArcGIS.",
    ChangesMustBeSavedBeforeRunningTheAutomation:
        "Changes must be saved before running the Automation.",
    CreateReportUseAdvancedDesignerMRT: "Use Advanced Designer: Multiple records on each page",
    CreateReportUseAdvancedDesignerSRT: "Use Advanced Designer: Single record on each page",
    SelectLocationToDisplayNeededMaterials: "Select Location to display needed materials.",
    LayoutHas250Sections: "This layout has 250 sections, the maximum number allowed.",
    SectionHas100Filters: "This section has 100 filters, the maximum number allowed.",
    AreYouSureYouWantToClearTheLog: "Are you sure you want to clear the log?",
    LookupGeodatabaseAttributes: "Attribute Associated through a Lookup",
    CannotCompleteAction: "Cannot Complete Action",
    CannotSelectMoreThanNItems:
        "More than {0} records are selected. Filter the selection to decrease the number of selected records.",
    CannotAddActivity: "Cannot Add Activity",
    CannotSelectMoreThanNActivities: "No more than {0} items may be selected at once.",
    CannotAddToProject: "Cannot Add To Project",
    CannotRemoveFromProject: "Cannot Remove From Project",
    CannotAddNoActivity:
        "Selection contains No Activity records. Remove items from selection before adding to a Project.",
    EnterStartingLocation: "Enter starting location or select on map",
    ReviewLayersToAnalyzeAgainst: "Review layers to analyze against:",
    AreYouSureYouWantToRemove: "Are you sure you want to remove {0}?",
    SelectATargetLayerToAnalyze: "Select a Target Layer to analyze:",
    CreateReportUseBasicDesignerChart: "Use Basic Designer: Chart",
    CreateReportUseBasicDesignerTable: "Use Basic Designer: Table",
    EnterEndingLocation: "Enter ending location or select on map",
    LocationsCannotBeTheSame: "Locations cannot be the same.",
    DeletionQuestion: "Are you sure you want to delete {0}?",
    SelectTransferToLocation: "Select Transfer To Location",
    AllRecordsWillBeRemoved: "All records will be removed.",
    AddProjectToScenario: "Add a project to the scenario.",
    WeDidntFindAnyResults: "We didn't find any results.",
    CannotAddTheCrewMember: "Cannot Add the Crew Member",
    CannotActionAssocation: "Cannot {0} Association",
    LaborAvatarsFailedToLoad: "Laborer Avatars failed to load",
    LaborRecordsFailedToLoad: "Laborer records failed to load",
    RecordsetAuditExport: "Recordset Audit Export",
    NoAutomationsToDisplay: "No automations to display. Click Create Automation to begin.",
    NoLogsToDisplay: "No logs to display",
    NoResultsFoundWithSearchTerm: "No results found for \"{0}\"",
    NoResultsFoundSubtitle:
        "Make sure your words are spelled correctly, or use fewer or different keywords.",
    SearchTrigger: "Search for Trigger",
    SearchAllAutomations: "Search all Automations",
    GeodatabaseAttribute: "Geodatabase Attribute",
    SynchronizeGeometry: "Synchronize Geometry",
    CannotSaveAutomation: "Cannot Save Automation",
    CannotSaveResourceEstimates: "Cannot Save Resource Estimates",
    CannotDuplicateAutomation: "Cannot Duplicate Automation",
    CannotDuplicateAutomationMessage:
        "Save the changes to the current automation before duplicating the automation.",
    AutomationDuplicated: "Automation Duplicated",
    CannotAddAutomationBlock: "Cannot Add Action",
    SelectALaborOrCrew: "Select a Laborer or Crew",
    EditProjectTitle: "Edit the project title.",
    SelectALaborer: "Select a Laborer",
    SelectARoleOrUser: "Select a Role or User",
    AllUsersAndRoles: "All Users and Roles",
    SelectTrigger: "Select a Trigger",
    AutomationsLog: "Automations Log",
    AutomationExecuting: "Executing Automation",
    AutomationScheduledImmediately: "Automation scheduled to run immediately.",
    TooManyAutomationBlocks: "The maximum number of actions already in use.",
    DistributeResources: "Distribute Resources",
    CopyEmailAddresses: "Copy email addresses",
    EnterProjectTitle: "Enter Project Title",
    DecreaseAdjustment: "Decrease Adjustment",
    IncreaseAdjustment: "Increase Adjustment",
    EditAssignedLabor: "Edit Assigned Labor",
    UnableToLocate: "Unable to locate \"{0}\"",
    RenameGroupHeader: "Rename Group Header",
    MapTitleDetailFor: "{0} Detail for {1}",
    LoadingTriggers: "Loading Triggers",
    CannotSaveReport: "Cannot Save Report",
    SelectReport: "Select Report",
    SelectReportType: "Select report type",
    SelectRecordType: "Select record type",
    CannotFindRecord: "Cannot Find Record",
    CannotAddSection: "Cannot Add Section",
    BudgetLimitation: "Budget Limitation",
    CannotAddTheLog: "Cannot Add the Log",
    EnterReportName: "Enter report name",
    StartingLocation: "Starting Location",
    CannotAddFilter: "Cannot Add Filter",
    RouteDirections: "Route Directions",
    AutomationManager: "Automation Manager",
    AutomationManagerLogs: "Logs",
    SaveUnderline: "<span>S</span>ave",
    CannotPrintMap: "Cannot Print Map",
    GISAssociation: "GIS Association",
    PrimaryGISAssoc: "Primary GIS Association",
    EndingLocation: "Ending Location",
    SelectMaterial: "Select Material",
    CreateAutomation: "Create Automation",
    AdvancedDesigner: "Advanced Designer",
    BasicDesigner: "Basic Designer",
    CannotLoadMap: "Cannot Load Map",
    StandardReport: "Standard Report",
    AllRecordsets: "All Recordsets",
    AllGadgetTypes: "All Gadget Types",
    CustomReport: "Custom Report",
    RenameSection: "Rename Section",
    GenerateRoute: "Generate Route",
    SaveRoute: "Save Route",
    EndTargetOCI: "End Target OCI",
    CreatingReport: "Creating Report",
    DuplicatingReport: "Duplicating Report",
    RouteDetails: "Route Details",
    ClearLibrary: "Clear Library",
    DuplicateReport: "Duplicate Report",
    RefreshReport: "Refresh Report",
    CannotRunNow: "Cannot Run Now",
    DeleteReport: "Delete Report",
    BulkTransfer: "Bulk Transfer",
    ManageLayers: "Manage Layers",
    SearchLayers: "Search Layers",
    EditAProject: "Edit a Project",
    SearchGadgets: "Search gadgets",
    ProjectTitle: "Project Title",
    TransferQty: "Transfer Qty",
    Relationship: "Relationship",
    AddAProject: "Add a Project",
    TotalBudget: "Total Budget",
    RoutedTasks: "Routed Tasks",
    Description: "Description",
    FinishSave: "Finish & Save",
    Orientation: "Orientation",
    EnterTitle: "Enter a Title",
    EditProject: "Edit Project",
    SelectView: "Select View",
    Searching: "Searching...",
    WorkOrders: "Work Orders",
    ClearField: "Clear Field",
    StopReport: "Stop Report",
    EditReport: "Edit Report",
    AddSection: "Add Section",
    AddProject: "Add Project",
    SelectAll: "Select All",
    OCITarget: "OCI Target",
    EnteredBy: "Entered By",
    OpenTasks: "Open Tasks",
    AssetType: "Asset Type",
    Resources: "Resources",
    Automations: "Automations",
    Automation: "Automation",
    CannotAdd: "Cannot Add",
    EditTitle: "Edit Title",
    SaveLayer: "Save Layer",
    Libraries: "Libraries",
    Recordset: "Recordset",
    LineItem: "Line Item",
    Category: "Category",
    FullName: "Full Name",
    Transfer: "Transfer",
    Activity: "Activity",
    Priority: "Priority",
    ViewType: "View Type",
    AddView: "Add View",
    Requests: "Requests",
    Complete: "Complete",
    Material: "Material",
    Advanced: "Advanced",
    ErrLog: "Error Log",
    Receive: "Receive",
    Finish: "Finish",
    Details: "Details",
    Reports: "Reports",
    ResetOms: "Reset OMS",
    TaskID: "Task ID",
    Assets: "Assets",
    SaveAs: "Save As",
    Reopen: "Reopen",
    Remove: "Remove",
    Street: "Street",
    Select: "Select",
    Field: "Field",
    Owner: "Owner",
    Clear: "Clear",
    Stock: "Stock",
    Basic: "Basic",
    Name: "Name",
    Keep: "Keep",
    Back: "Back",
    Next: "Next",
    Forward: "Forward",
    Month: "Month",
    Week: "Week",
    Type: "Type",
    Work: "Work",
    Lock: "Lock",
    ID: "ID",
    PM: "PM",
    AM: "AM",
    SpacePM: " PM",
    SpaceAM: " AM",
    High: "High",
    Low: "Low",
    Moderate: "Moderate",
    Excellent: "Excellent",
    Good: "Good",
    Average: "Average",
    Fair: "Fair",
    Poor: "Poor",
    Failed: "Failed",
    OID: "oid",
    GoToDate: "Go To Date",
    AssetAdministration: "Asset Administration",
    VersaCGAppNames: ["Asset Builder Point", "Asset Builder Linear", "Asset Builder Polygon"],
    Structure: "Structure Manager",
    StructureMgrProtectedNames: [
        "cgWorkOrders",
        "cgTasks",
        "cgRequests",
        "cgLabor",
        "cgLaborCrew",
        "cgEquipment",
        "cgMaterials",
        "cgMaterialLocations",
        "cgMaterialOrders",
        "cgMaterialPlanning",
        "cgVendors",
        "cgLog",
        "cgOtherLog"
    ],
    PluralDuplicateName: "Plural Name must be unique. The {0} Plural Name exists.",
    PluralDuplicateNameInUnavialable:
        "Plural name must be unique. {0} exists as a Cartegraph standard asset.",
    SingularDuplicateName: "Singular Name must be unique. The {0} Singular Name exists.",
    SingularDuplicateNameInUnavialable:
        "Singular name must be unique. {0} exists as a Cartegraph standard asset.",
    Installed: "Installed",
    Available: "Available",
    UnvailableStandardAsset: "UnvailableStandardAsset",
    DuplicateUserId: "ID must be unique. The {0} ID exists.",
    TableDuplicateName: "Table Name must be unique. The {0} table exists.",
    FieldDuplicateName: "Field name must be unique. The {0} field exists.",
    ColumnDuplicateName: "Column name must be unique. The {0} column exists.",
    GreaterThanZero: "{0} must be greater than 0.",
    AssetConditionManager: "Asset Condition Manager",
    NotificationManager: "Notification Manager",
    AssetColorManager: "Asset Color Manager",
    LibraryManager: "Library Manager",
    LayoutManager: "Layout Manager",
    BaseMapAdmin: "Map Administration",
    UserAdmin: "User Administration",
    RoleAdmin: "Role Administration",
    Administration: "Administration",
    SystemSettings: "System Settings",
    ScenarioBuilder: "Scenario Builder",
    ScheduledProcessLog: "Scheduled Processes",
    GeocodeSettings: "Geocode Settings",
    Settings: "Settings",
    Budgets: "Budgets",
    Project: "Project",
    Projects: "Projects",
    PlanYears: "Plan Years",
    PlanYear: "Plan Year",
    Protocol: "Protocol",
    Protocols: "Protocols",
    XWorkOrdersSelected: "{0} Work Orders Selected",
    OneWorkOrderSelected: "1 Work Order Selected",
    InvalidTimeFormat: "Invalid time format",
    InvalidDateFormat: "Invalid date format",
    FailRetrieveFieldListErrMsg: "Failed to retrieve field list for class{0}. Error: {1}",
    CostPerPlanYear: "Cost Per Plan Year",
    ConvertToWork: "Convert to Work",
    SearchProjects: "Search Projects",
    WindowVMInstanceMustReturnsCarteVMWV:
        "windowViewModelInstance must be a function that returns a Cartegraph.ViewModels.WindowViewModel",
    WindowVMInstnaceMustReturnsCarteVMBV:
        "windowViewModelInstance must be a function that returns a Cartegraph.ViewModels.BaseViewModel",
    WindowVMInstanceTypeCarteVMWVRequired:
        "windowViewModelInstance of type Cartegraph.ViewModels.WindowViewModel required",
    WindowVMInstanceTypeCarteVMBVRequired:
        "windowViewModelInstance of type Cartegraph.ViewModels.BaseViewModel required",
    WindowVMOverridesetModels: "Must override WindowViewModel setModels",
    WindowVMOverrideDispose: "Must override WindowViewModel dispose",
    WindowVMOverrideSave: "Must override WindowViewModel save",
    NonLocationGridVMOverrideAdd: "Must override NonLocationAssetGridViewModel add",
    NonLocationGridVMOverrideRemove: "Must override NonLocationAssetGridViewModel remove",
    NonLocationGridVMOverrideGetAssets:
        "Must override NonLocationAssetGridViewModel getSelectedAssets",
    ImportExportBaseSelectionVMOverrideSave:
        "Must override ImportExportBaseSelectionViewModel save",
    EventNameCannotHaveNamespace: "eventName can't contain a Namespace!",
    SelectedUnitsIncompatibleNoConverted:
        "Selected units are incompatible and cannot be converted.",
    CannotChangeUnit: "Cannot Change Unit",
    CannotConvertUnitMessage: "Cannot convert {0} {1} to the unit of {2}.",
    BadRecordsetMeta: "Bad recordsetMeta",
    BadRecordMeta: "Bad recordMeta",
    BadFieldMeta: "Bad fieldMeta",
    TurnEncryptionOffButton: "Turn Encryption Off",
    KeepEncryptionOnButton: "Keep Encryption On",
    TurnEncryptionOffTitle: "Are you sure you want to turn encryption off?",
    TurnEncryptionOffMessage:
        "Turning encryption off clears the value. New values display decrypted.",
    TurnEncryptionOnTitle: "Are you sure you want to turn encryption on?",
    TurnEncryptionOnMessage:
        "Turning encryption on replaces the value with an encrypted version. The decrypted value does not display.",
    TurnEncryptionOnButton: "Turn Encryption On",
    KeepEncryptionOffButton: "Keep Encryption Off",
    HourMustBetw1And12: "Hour must be between 1 and 12. (or 0 and 23 for military time)",
    CannotSpecifyAmOrPmMilitary: "You cannot specify AM or PM for military time",
    CannotDivideByZero: "Cannot divide by zero",
    InvalideDate: "invalid date",
    CreateTask: "Create Task",
    CreateXTasks: "Create {0} Tasks",
    Format: "Format",
    Install: "Install",
    Commit: "Commit",
    MinMustBetw0And59: "Minute must be between 0 and 59.",
    SecMustBetw0And59: "Second must be between 0 and 59.",
    ClassMetaIsNull: "classMeta is null",
    CouldNotGetModel: "Could not get the model.",
    ClassNameIsRequired: "className is required.",
    BaseNameSpaceIsRequired: "baseNamespace is required.",
    RequiredWhen: "{0} requires a value when {1}.",
    ErrUploadLibraryAttachment: "Error uploading Library Attachment",
    JSErrFileLineNumMsg: "JavaScript Error\nFile: {0}\nLine Number: {1}\nMessage: {2}",
    ObjErrExpandoCollapso: "In-session object error, no ID on expanded or collapsed state!",
    NoBIDForURIMayNotCalled: "No BID for URI! Proper URI function may not have been called!",
    SampleAreaMissingNoDivByZero: "Sample Area missing, cannot divide by zero",
    SampleAreaMissing: "Sample Area missing",
    SampleLengthMissing: "Sample length parameter missing when calculating distress area",
    PavementWidthMissing: "Pavement width parameter missing when calculating distress area",
    CannotSelectAll: "Cannot Select All",
    CannotBeInMsgMoreThanOnce: " cannot be in the message more than once.",
    CannotBeInViewMoreThanOnce: " cannot be in the view more than once.",
    PreventativeMaintenance: "Preventative Maintenance",
    PreventativeMaintenanceHeader: "Preventative Maintenance Plans",
    PreventativeMaintenanceHasMaxPlans:
        "Your account has reached the maximum number of {0} Preventative Maintenance plans.",
    RecordSet: "Recordset",
    Library: "Library",
    PMFindAPlan: "Search",
    Import: "Import",
    Export: "Export",
    InvalidFormat: "Invalid Format",
    ImportExport: "Import / Export",
    ImportingJob: "Importing Job",
    ExportingJob: "Exporting Job",
    SortSelectedRecords: "Sort Selected Records",
    SelectCategory: "Select Category",
    SelectTimeInterval: "Select Time Interval",
    SelectType: "Select Type",
    SelectFormat: "Select Format",
    SelectDataSource: "Select Data Source",
    InvalidImportDataSourceFile: "{file} is invalid. Select a .csv, .txt, or .tab file.",
    ValidImageTypes: "image/jpeg,image/bmp,image/gif,image/png",
    InvalidImageFile:
        "{file} is an invalid file type. Select an image file type of .bmp, .png, .gif, .jpg, or .jpeg.",
    FileUploaderInvalidFileTitle: "Invalid File",
    DeleteCOFCriteriaTitle: "Delete criteria and recalculate risk scores?",
    DeleteCOFCriteriaMessage:
        "If this Consequence of Failure criteria is deleted, the corresponding field is removed from the {0} Detail view, and any stored data is permanently deleted. The Consequence of Failure and overall Risk scores are recalculated for all asset records of this type.",
    CannotEditStructureTitle: "Cannot Update System Structure",
    CannotEditStructureBody: "You cannot edit system structure because you do not have permission to access Structure Manager. Ask your System Administrator for help.",
    CantOpenFile:
        "{0}'s file extension does not match the file type and will not open. Select a file with the correct file extension",
    FileUploaderEmptyErrorMessage: "{0} is empty. Select a valid file to continue.",
    FileUploadTypeErrorMessage: "{file} is invalid. Select a file with the correct file type.",
    FileUploadSizeErrorMessage: "{file} is invalid. Files cannot be larger than {sizeLimit}.",
    FilterTimeoutErrorTitleAdvFilter: "Cannot Apply Filter",
    FilterTimeoutErrorMessageAdvFilter:
        "This invalid filter caused a timeout. Change the filter and try again.",
    FilterTimeoutErrorTitleColorCount: "Cannot Apply Filter",
    FilterTimeoutErrorMessageColorCount:
        "An invalid filter caused a timeout. Change the filter and try again.",
    ModelSaverBadModelException:
        "Model is required and must be a instance of Cartegraph.Models.cgBase",
    RequiresJsDateObject: "{0} requires a JavaScript Date object",
    CanceledSeeLog: "Canceled - See Log",
    CompleteSeeLog: "Complete - See Log",
    Review: "Review",
    Success: "Success",
    SelectConditionTrigger: "Select Trigger Type",
    EstimatedOCI: "Estimated OCI",
    InspectedOCI: "Inspected OCI",
    MinimumIsReached: "Minimum is Reached",
    NoFilterApplied: "– No filter applied",
    Every: "Every ",
    Beginning: " beginning ",
    AfterThePrevious: " after the previous ",
    TimeOnly: "Time Only",
    TimeAfterComplete: "Time After Complete",
    Condition: "Condition",
    Time: "Time",
    Repeat: "Repeat",
    Usage: "Usage",
    UsageText: " Every {0} {1} since the last {2} was completed",
    UsageEditText: "{0} since the last {1} was completed",
    PMClassName: "cgPrevMaintPlansClass",
    PMScheduleClassName: "cgPrevMaintPlans_cgPrevMaintSchedulesClass",
    PMNoPlansCreated: "No Plans Created",
    PMNoPlansFound: "No Plans Found",
    WasCompletedStarting: " was completed, starting ",
    Yes: "Yes",
    No: "No",
    EstimatedOciFalls: "Estimated OCI falls below ",
    InspectedOciFalls: " Inspected OCI falls below ",
    MinimumConditionIsReached: " Minimum Condition is reached ",
    FallsBelow: "falls below ",
    SavePlanNoFilterTitle: "Are you sure you want to activate this plan?",
    SavePlanNoFilterBody: "Plan {0} does not have a filter and will apply to {1} {2}.",
    SavePlanNoFilterButton: "Activate without Filter",
    DuplicatePlanIdTitle: "Cannot Add the Plan",
    DuplicatePlanIdErrorMessage: "{0} already exists. Enter a unique Plan name.",
    NotificationUnsubscribeFail: "Failed to unsubscribe. Please try again.",
    NotificationUnsubscribeSuccess: "You have been successfully unsubscribed.",
    RecordsSaved: "Records Saved",
    RecordsExported: "Records Exported",
    RecordsProcessed: "Records Processed",
    CannotCreatePlanTitle: "Cannot Create Plan",
    CannotCreatePlanMessage: "Asset Type must be selected.",
    DeletePlanTitle: "Are you sure you want to delete the plan?",
    DeletePlanMessage: "The plan will be deleted.",
    DeletePlan: "Delete Plan",
    KeepPlan: "Keep Plan",
    EnterPlanName: "Enter Plan Name",
    PlanName: "Plan name",
    CancelActivation: "Cancel Activation",
    DeleteActivityTitle: "Are you sure you want to remove the activity?",
    DeleteActivityMessage: "The activity will be removed from the plan.",
    KeepActivity: "Keep Activity",
    DeleteActivity: "Remove Activity",
    KeepTrigger: "Keep Trigger",
    RemoveTrigger: "Remove Trigger",
    Trigger: "Trigger",
    DeleteTriggerTitle: "Are you sure you want to remove the trigger ?",
    DeleteTriggerMessage: "The trigger will be removed from the activity.",
    CancelTriggerEditHeader: "Cancel Trigger Edit",
    CancelTriggerEditMessage: "Are you sure you want to cancel the changes made to this trigger?",
    ResetNotificationManagerTitle: "Are you sure you want to reset the notifications?",
    ResetNotificationManagerMessage: "Notifications will return to the previous state.",
    ResetChanges: "Reset Changes",
    KeepChanges: "Keep Changes",
    KeepChange: "Keep Change",
    ChangeFieldTypeTitle: "Are you sure you want to change the field type?",
    ChangeFieldTypeMessage:
        "This change updates existing data to match the new field type. This process may take a long time.",
    KeepFieldType: "Keep Field Type",
    ChangeFieldType: "Change Field Type",
    MultipleUniqueAndRequiredTitle: "Another Field is Marked Unique and Required",
    RelationshipExplanation:
        "Relationships allow you to share access to a recordset’s data with other recordsets in your database. Select the recordset you want to share {0} with below:",
    ContainerComponentExplanation:
        "Container/Component relationship. {0} total costs and condition estimates include {1} using the weight below.",
    ContainerComponentDisabledExplanation:
        "{0} cannot be a container to {1} because it already exists as component below {1} in the hierarchy.",
    SelectRecordset: "Select Recordset",
    NameRecordset: "Name Recordset",
    ActivateAs: "Active as of {0}",
    IsoDateFormat: "yy-mm-dd",
    IsoDateTimeFormat: "yy-mm-ddTH:mm:ssZ",
    InvalidUsageFilterTitle: "Cannot Add Usage Trigger",
    InvalidUsageNoRecordsMessage:
        "The plan must contain a minimum of one record. Edit the plan filter to continue.",
    InvalidUsageFilterDifferentUnitsMessage:
        "The plan’s filter contains {0} records with different units. Edit the plan filter to contain {0} records with a classification.  All classifications in the filter set must contain the same unit type.",
    InvalidUsageFilterNoUnitsMessage:
        "The plan’s filter contains no {0} records with units. Edit the plan filter to contain {0} records with one unit type or make sure the {0} records are assigned a classification.",
    RecordHasNoUnitLower: "record has no unit",
    RecordsHaveNoUnitLower: "records have no unit",
    RecordUsesLower: "record uses",
    RecordsUseLower: "records use",
    TaskStatus: {
        Projected: "Projected",
        Planned: "Planned",
        Completed: "Completed",
        Canceled: "Canceled",
        InProgress: "In Progress"
    },
    WorkOrderStatus: {
        Planned: "Planned",
        Completed: "Completed",
        Canceled: "Canceled",
        InProgress: "In Progress"
    },
    ProjectedOrOpenTaskForThisAsset: "Related Work Item",
    ProjectedOrOpenTasksForThisAsset: "Related Work Items",
    ConvertingProjectedTask: "Converting Projected Task",
    SelectedActionNotAvailableForProjectedTasks:
        "Selected Action Not Available for Projected Tasks",
    RemoveAllSelectedTasksWithStatusProjected:
        "Remove all selected Tasks with a status of Projected. Action menu items do not apply to Projected Tasks.",
    AddToContainer: "Add To This Container",
    ConnectionExistsTitle: "Connection Already Exists",
    ConnectionExistsSingularMessage:
        " is already a connected component in another container. Are you sure you want to connect this component to this container?",
    ConnectionExistsPluralMessage:
        " are already connected components in another container. Are you sure you want to connect these components to this container?",
    KeepCurrentContainer: "Keep Current Container",
    ContainerComponent: "Container/Component",
    LinkableAsset: "Linkable asset",
    RelationshipTo: "Relationship to ",
    RecordArchivesDesc:
        "Audit Recordset allows you to audit changes made to this recordset's data. Audit entries are saved for record additions, changes, and deletions.",
    SelectConnection: "Select Connection",
    EditingNonLocationAssetConnections: "Editing Non Location Asset Connections",
    IssueFieldRequired: "Issue is a required field and must be added to continue.",
    CannotSave: "Cannot Save Changes",
    CannotSaveFile: "Cannot Save File",
    CannotLoadFile: "Cannot Load File",
    InternalRequestRole: "Default Internal Request User",
    CannotAddThe: "Cannot Add the {0}",
    SelectingNonLocationAssets: "Selecting Non Location Assets",
    SelectNonLocationAsset: "Select Non Location Asset",
    ThisFunctionMustBeOverridden: "This function must be overridden.",
    ArgumentIsNullOrUndefined: "{0} argument is null or undefined.",
    InvalidArgumentValue: "{0} argument has an invalid value.",
    ParamsObjectIsNotAnInstanceOf: "The params object is not an instance of {0} .",
    AllScenarios: "All Scenarios",
    PredictionGroup: "Prediction Group",
    ConditionGroup: "Condition Group",
    Scenario: "Scenario",
    ScenarioEditedRerunRequired: "Rerun Required",
    ExportActivitiesWithAssetAttributes: "Export Activities with Asset Attributes",
    LineSeparator: "LineSeparator",
    ExportActivitiesToTasks: "Export Activities To Tasks",
    NoCCToDisplay: "No condition categories to display",
    SelectionNotAvailable: "Selection not available.",
    FixTheFollowingToContinue: "Fix the following to continue:",
    FieldDoesNotExistRemoveFieldToContinue: "Field does not exist. Remove field to continue.",
    RemoveField: "Remove field",
    Width: "Width:",
    ValueMustBeNumberGreaterThan0: "Value must be a number greater than 0.",
    OCIWeight: "OCI Weight",
    NextAvailableNumber: "Next Available Number",
    MaximumCharacters: "Maximum Characters",
    LookupRSet: "Lookup Recordset",
    UniqueField: "Unique Field",
    UnitCategory: "Unit Category",
    UnitDefault: "Default Unit",
    NumberMinLength: "Number Minimum Length",
    SQLStatement: "SQL Statement",
    Connection: "Connection",
    ConnectionStringDoesNotExist:
        "Connection String does not exist. Select a valid Connection String to continue",
    UseSpecialFunction: "Use Special Function",
    SourceData: "Source Data",
    IncomingDataSource: "Incoming Data Source",
    TargetRecordset: "Target Recordset",
    ElementIsMissingAnId: "The element is missing an id.",
    UniqueIdForKOInSessionPersistence:
        "A unique element id per namespace for the current URI session is required when using the inSessionPersist binder in order to match session data with the correct view model instance.",
    TargetRecordsetCategory: "Target Recordset Category",
    TargetRecordsetType: "Target Recordset Type",
    TargetField: "Target Field",
    Target: "Target",
    ValueField: "Value Field",
    Mask: "Mask",
    UseCustomCoordinateSystem: "Use Custom Coordinate System",
    GeographicWorldWGS1984: "Geographic.World.WGS1984",
    SelectingCoordinateSystem: "Selecting Coordinate System",
    TimeFirst: "Time First",
    TimeFormat: "Time Format",
    DateFormat: "Date Format",
    ClearJobHistoryMsg: "The completed run history will be lost if you continue.",
    ClearJobHistoryTitle: "Are you sure you want to clear the run history?",
    ClearSpecificJobHistoryMsg: " run history will be lost if you continue.",
    KeepRunHistory: "Keep Run History",
    ClearRunHistory: "Clear Run History",
    Index: "Index",
    Year: "Year",
    Ra: "Ra",
    ClearAllPoints: "Clear All Points",
    ClearAllImpacts: "Clear All Impacts",
    ClearAllMappings: "Clear All Mappings",
    CopyPoints: "Copy Points",
    PointsCopied: "Points copied successfully.",
    PasteCopiedPoints: "Paste Copied Points",
    AddPoint: "Add Point",
    RemovePoint: "Remove Point",
    AddMapping: "Add Mapping",
    RemoveMapping: "Remove Mapping",
    AddImpact: "Add Impact",
    RemoveImpact: "Remove Impact",
    EditProperties: "Edit Properties",
    ManagingServers: "Managing Servers",
    CannotConnectArcGIS:
        "Cannot connect with ArcGIS server. Not all Geodatabase Attributes are displayed.",
    Private: "Private",
    TestConnection: "Test Connection",
    Testing: "Testing...",
    ServerName: "Server Name",
    ServerURL: "Server URL",
    DefaultGISNewServerName: "Server Name",
    DefaultGISNewServerURL: "https://[server.domain.com]/arcgis",
    AreYouSureYouWantToSave: "Are you sure you want to save?",
    AreYouSureYouWantToSaveTmpl: "Are you sure you want to save {0}?",
    SaveServer: "Save Server",
    NoArcGisServer: "No ArcGIS Server",
    AnArcGISServerMustBeAdded:
        "An ArcGIS Server must be added before creating associations. Select Manage Servers to add an ArcGIS Server.",
    CannotDeleteGisServer: "Cannot delete GIS Server because it is referenced elsewhere.",
    CannotDeleteGisServerNamed: "{0} is referenced by other records.",
    AreYouSureChangeAssociationMsg:
        "If you change the {0} field, the other Data Source fields and any Field Associations may clear.",
    SaveHasUidErrorsTitle: "Cannot Save Layout View",
    SaveHasUidErrors:
        "Duplicate fields or grids exist. Fields and grids can only display in a Task Detail view one time. Remove the duplicate field or grid in the section or fix the filters so it only displays one time. {0}",
    SoeNotEnabledTitle: "Cartegraph SOE Not Enabled",
    SoeNotEnabledMessage:
        "The Cartegraph SOE is required for real-time updates when the Cartegraph Add-in is installed in ArcMap or ArcGIS Pro. If the Cartegraph SOE is not enabled for a two-way integration, manual syncs are required for ArcMap/ArcGIS Pro edits to display in Cartegraph.",
    CannotSaveAssociation: "Cannot Save Association",
    CancelChange: "Cancel Change",
    ContinueChange: "Continue with Change",
    FeatureService: "Feature Service",
    FeatureClassLayer: "Feature Class Layer",
    CartegraphRecordset: "Cartegraph Recordset",
    LinearFeatureClassField: "Linear Feature Class Layer",
    LinearIDField: "Linear Task ID Association",
    PolygonFeatureClassField: "Polygon Feature Class Layer",
    PolygonIDField: "Polygon Task ID Association",
    RequiredWhenUsingFullGeometry: "The {0} is required when Include Full Geometry is enabled.",
    GISStringTruncation:
        "The {0} field data is too long and would be truncated. Correct the Cartegraph data, increase the Geodatabase field size, or associate to a larger Geodatabase Attribute.",
    GISMemoError:
        "The {0} attribute cannot be associated to the primary field.  Decrease the Geodatabase field size or associate to a smaller Geodatabase Attribute.",
    EditTrackingNotEnabledMessage:
        "Edit Tracking is not enabled for the Feature Class Layer, or the Edit Date Field is missing.",
    CannotContactServer: "Cannot Contact Server",
    CannotEditAssociationsMessage:
        "You are not able to edit any of the Field Associations because the ArcGIS Server connection was lost. Check the server settings or contact Cartegraph Technical Support for help.",
    CannotEditFeatureServiceTitle: "Cannot Edit the Association",
    CannotEditFeatureServiceMessage:
        "You are not able to edit the Association because the ArcGIS Server is not configured properly. Check the ArcGIS Server Manager settings or contact Cartegraph Technical Support for help.",
    CannotEditTheAsset: "Cannot Edit the {0}",
    CannotEditGeometry: "Cannot Edit Geometry",
    CannotAddTheAsset: "Cannot Add the {0}",
    CannotCreateAssetInGeometricNetwork:
        "{0} are part of a geometric or utility network in GIS and cannot be created in Cartegraph. You must create the record in GIS.",
    CannotDuplicateAssetInGeometricNetwork:
        "{0} are part of a geometric or utility network in GIS and cannot be duplicated in Cartegraph. You must create the record in GIS.",
    CannotEditGeometricNetwork:
        "{0} are part of a geometric or utility network in GIS, so geometry cannot be edited in Cartegraph. You must edit the geometry in GIS.",
    MandZAwareFeatureServiceMessage:
        "M-aware or Z-aware is enabled for the Feature Class Layer.",
    UpdateGeometryFeatureServiceMessage:
        "Allow Geometry Edits is not enabled for the Feature Service.",
    MandZAwareAndUpdateGeometryFeatureServiceMessage:
        "M-aware or Z-aware is enabled for the Feature Class Layer and when Allow Geometry Edits is not enabled for the Feature Service.",
    CannotDeleteGeometricNetwork:
        "{0} are part of a geometric or utility network in GIS and cannot be deleted in Cartegraph. You must delete the record in GIS.",
    FeatureOutsideBoundary: "The feature is outside the map boundary.",
    CgRemaining: "Cartegraph Records to Process",
    GisRemaining: "GIS Records to Process",
    RecordsInSync: "Records In Sync",
    RecordsSynced: "Synced",
    RecordsAdded: "Added",
    RecordsSkipped: "Skipped",
    RecordsFailed: "Failed",
    DownloadLog: "Download Log",
    DownloadRtLog: "Download Interval Log",
    Completed: "Completed",
    Started: "Started",
    Running: "Running",
    Waiting: "Waiting",
    RunStatus: "Run Status:",
    Canceled: "Canceled",
    RunStatusCanceling: "Canceling",
    SynchronizingAssociations: "Synchronizing Associations",
    Synchronizing: "Synchronizing",
    NewField: "<New Field>",
    NewLibrary: "<New Library>",
    NewUniqueID: "<New Unique ID>",
    CartegraphLibrary: "Cartegraph Library",
    CannotCancelSynchronization: "Cannot Cancel Synchronization",
    CannotRefreshSynchronization: "Cannot Synchronize Association",
    CannotRefreshSynchronizationMsg:
        "The Association did not synchronize because the {0} server could not be contacted.",
    AttemptsFailedSynchronizationMsg:
        "Several attempts to synchronize the association were not successful. Verify the association and run Synchronize again. If you continue to have problems, contact Cartegraph Technical Support.",
    CannotDownloadLog: "Cannot Download Log",
    CannotEditListInLibraryManager: "Cannot edit the list in Library Manager.",
    CannotLoadLibraryPropertiesTitle: "Cannot Load Library Properties",
    CannotLoadLibraryPropertiesMessage:
        "Cannot load properties for the {0} library. Select the library again and if you still have problems, ask your System Administrator for help.",
    MakeChangesToDomainInArcCatalog: "Use GIS to make changes to the {0}.",
    AreYouSureChangeTheDefault: "Are you sure you want to change the default?",
    DefaultGroupChanged: "The Default {0} will be changed from {1} to {2}.",
    EditDefault: "Edit Default",
    GISAttribute: "GIS Attribute",
    GeometricNetwork: "Geometric or Utility Network",
    GISOneWayFromCg: "One-Way from Cartegraph to GIS",
    GISOneWayFromGis: "One-Way from GIS to Cartegraph",
    GISTwoWay: "Two-Way",
    CannotSetGeometricNetwork: "Cannot Set Geometric Network",
    RecordsetMustBeEmptyForGeometricNetwork:
        "Cannot select the Geometric Network check box for the selected Cartegraph recordset. The Cartegraph recordset must be empty before setting the association as a Geometric Network.",
    RecordsetMustBeEmptyForUtilityNetwork:
        "Cannot select this recordset because it has records, and the selected feature layer is part of a utility network. Utility network layers can only be associated with empty recordsets.",
    SpatialEditsInGIS:
        "By selecting this option, create, delete, duplicate, and spatial edits are prevented in Cartegraph and must be done in GIS.",
    Configuration: "Configuration",
    PortalURL: "Portal URL",
    DefaultGISNewPortalURL: "https://[portal.domain.com]/portal",
    GetScenarioAssetData: "Get Scenario and Asset Data",
    CalculateMissingAssetPerformanceData: "Calculate Missing Asset Performance Data",
    ProcessScenario: "Process Scenario",
    SaveScenarioResults: "Save Scenario Results",
    AssetCriticality: "Asset Criticality",
    AssetCriticalityHighestEstimatedOCI: "Asset Criticality and Highest Estimated OCI",
    AssetCriticalityLowestEstimatedOCI: "Asset Criticality and Lowest Estimated OCI",
    ScenarioWeightError: "Asset Prioritization is set to \"Asset Criticality and Estimated OCI\"",
    CancelComplete: "Cancel Complete {0}",
    ContinueToComplete: "Continue to Complete {0}",
    CompleteDialogTitle: "Are you sure you want to complete the {0}?",
    Completing: "Completing Tasks...",
    CannotCompleteSelectedRecords: "Cannot Complete Selected Tasks",
    BulkCompleteTaskMessage: "{0} {1} will be completed.",
    BulkEditDialogTitle: "Bulk Editing {0} Record{1}",
    BulkEditDialogSubtitle: "Select the fields to edit and enter the new values.",
    BulkEditConfirmationTitle: "Are You Sure?",
    BulkEditConfirmationMessage: "When you click Yes, changes to {0} record{1} will be made and cannot be undone.",
    BulkEditEmptyFields: "The following fields were left empty, which will remove the existing values from the records being edited:",
    BulkEditEmptyActivityList: "The selected records do not share an Activity. Change the tasks selected to include at least one shared Activity.",
    BulkEditCannotLoadCOFTitle: "Cannot Load Data",
    BulkEditCannotLoadCOFMsg: "Cannot load data for the {0} field. Ask your System Administrator for help.",
    Budget: "Budget",
    HighestRisk: "Highest Risk",
    TargetOCI: "Target OCI",
    ScenarioRerun:
        "You are about to re-run this scenario. All previous results are cleared and updated asset data is gathered.",
    ScenarioRerunAreYouSure: "Are you sure you want to re-run this scenario?",
    ScenarioBudgetRequired: "Budget Limitation scenarios need at least one budget.",
    ScenarioProtocolRequired: "A scenario needs at least one protocol.",
    ScenarioPlanYearRequired: "A scenario needs at least one plan year.",
    ScenarioNoBudgetForCategory:
        "You have triggers with Budget categories without a corresponding budget. Add a budget to the scenario for the {0} budget {1}.<br/><br>If you don’t add a budget, the associated activities cannot be recommended.",
    ScenarioNoTriggerForBudget:
        "The {0} budget category does not have a trigger using this budget category.  Set at least one trigger to this category.<br/><br>If you don’t add triggers, no money is spent for this budget.",
    ScenarioNoTriggerForBudgets:
        "The {0} budget categories do not have triggers using these budget categories.  Set at least one trigger to these categories.<br/><br>If you don’t add triggers, no money is spent for this budget.",
    ScenarioSelectActivity: "Select Activity",
    ScenarioSelectYear: "Select Year",
    ScenarioStaleEOCI: "Re-run Scenario",
    ScenarioNAEOCI: "N/A",
    ScenarioActivityPaneDescription:
        "Set the activity and plan year and lock the records to the scenario.",
    ScenarioProjectPaneDescription:
        "Group activities to be performed together and convert into a work order and tasks.",
    ScenarioViewPaneDescription: "Select specific projects to view on the map.",
    StopAndMakeChanges: "Stop and Make Changes",
    ActivitiesNotRecommended:
        "If you don’t add a budget, the associated activities cannot be recommended.",
    AreYouSureYouWantToContinue: "Are you sure you want to continue?",
    PwpStatusCriticalErrors: "Critical Errors",
    ActivityCostPerPlanYear: "Activity Cost per Plan Year",
    BudgetVsCostPerPlanYear: "Budget vs Cost per Plan Year",
    CostForImpactPerScenario: "Cost for Impact per Scenario",
    ImpactPerScenario: "Net OCI Gain per Scenario",
    BudgetVsCostPerScenario: "Budget vs Cost per Scenario",
    CurrentUserDoesNotHaveAssociatedLaborRecord:
        "The current user does not have an associated Labor record. Ask your System Administrator for help.",
    RecordFilterAdmin: "Record Filter Administration",
    RecordFilterLimitReachedTitle: "Cannot add Record Filter",
    RecordFilterLimitReachedMessage: "The maximum number of Record Filters already in use",
    DeleteFilterTitle: "Are you sure you want to remove the Recordset Filter?",
    DeleteFilterMessage: "The filter will be permanently removed from the system.",
    DeleteFilter: "Remove Filter",
    MaterialLocationSummaryChartTitle: "Past 24 Month Usage Comparison",
    TaskEstimateVsActualCostChartTitle: "Estimated vs Actual Costs",
    MaterialMove: "Transfer Material",
    RepairLog: "Repair Log",
    NoMaterials: "No materials below reorder point",
    OrderingProcess: "Ordering Process:",
    OrderEdit: "Viewing Order:",
    OrderReceive: "Receiving Order:",
    DeleteAttachmentTitle: "Are you sure you want to delete the attachment?",
    DeleteAttachmentMessage: "The attachment will be deleted.",
    KeepAttachment: "Keep Attachment",
    DeleteAttachment: "Delete Attachment",
    SelectLocations: "Select Locations",
    SelectOrganization: "Select Organization",
    SelectIntegration: "Select Integration",
    SelectaValue: "Select a value",
    ChooseVendor: "Filter By Vendor to Generate Order",
    SelectYourLocations: "Select Your Location(s)",
    IncludeMobileLocations: "Include Mobile Locations:",
    UnitPrice: "Unit Price",
    NotAllMaterialsOrdered: "Not all Materials below reorder point have been reordered.",
    InvalidAddOrderItemTitle: "Cannot Add Line Item",
    InvalidBulkTransferItemTitle: "Cannot Transfer Line Item(s)",
    InvalidBulkTransferItemMessage: "Not all line items could be transferred.",
    MaterialLocationItemAlreadyExistsMessage:
        "A Line Item for this Material and Location already exists.",
    PriceRequiredOnReceive: "Price required when receiving material.",
    MaterialItemAlreadyExistsMessage: "A Line Item for this Material already exists.",
    CannotEditLogHeader: "Cannot Edit Log",
    CannotSaveRecord: "Cannot Save Record",
    SmartFieldMustBeReadOnly:
        "Read-only must be set to true when Calculation expression is entered.",
    ExchangeAsset: "Exchange Asset",
    CannotExchangeAsset: "Cannot Exchange Asset",
    CannotExchangeAssetWithNoParent: "Cannot exchange an asset that does not have a parent.",
    Apps: "Apps",
    AppSuccessfullyInstalled: "App Successfully Installed",
    SelectedAssetsWillNotBeInstalled: "The selected assets will not be installed.",
    SelectAvailableAssets: "Select Available Assets",
    YearsCantBeUsedWithApplyOnce: "Years cannot be used when Apply Once is selected.",
    CannotLoadShareData: "Unable to load sharing data",
    //#region Section Filtering
    SectionFiltersCopied: "Filters copied",
    SectionFiltersPasted: "Filters pasted",
    SectionFilteringErrorTitle: "Cannot Add Section Filtering",
    SectionFilteringErrorMessage: "Correct the errors to continue.",
    SectionFilteringSingleError:
        "are already added as a filter. Remove the duplicate or update the filter so it is not duplicate.",
    SectionFilteringMultipleErrors:
        "Duplicate asset and activity combinations are not allowed. Remove or update the filters so they are not duplicates. \n \n",
    InvalidTaskFilter: "Invalid filter. An activity is required.",
    DuplicateTaskFilter:
        "Duplicate filter. The same asset and activity combination can only be used one time.",
    //#endregion
    //#region Routing
    CannotGenerateRoute: "Cannot Generate Route",
    CannotAddTasksToRoute: "Cannot Add Tasks to Route",
    FilterTasksToRoute:
        "More than 150 Tasks that can be used, including the starting location and ending location, are selected. Filter the list to less than 149.",
    MinimumTasksToRoute: "A minimum of 1 Task must be Planned or In Progress and have a location.",
    SingleUnroutableTask: "1 Task is Projected, Completed, Canceled, or does not have a location.",
    MultipleUnroutableTasks:
        "{0} Tasks are Projected, Completed, Canceled, or do not have a location.",
    ContineToRouteRemainingTasks: " Continue to route the remaining {0} Task{1}?",
    ContinueWithRoute: "Continue with Route",
    CancelRoute: "Cancel Route",
    //#endregion
    //#region Spatial Analysis
    ViewText: "View Text",
    ViewGrid: "View Grid",
    NoRecordsToAnalyze: "No Records to Analyze",
    NoRecordsToAnalyzeMessage:
        "No records are in the Layer to analyze. The Layer must contain records with location and display on the Map when the Spatial Analysis is selected.",
    NoResultsFound: "No Results Found",
    NoSpatialSelectionResults:
        "No records found with Spatial Analysis. Run the analysis again with different expressions.",
    NoRecordsInMapExtent:
        "No records found in your map extent to analyze. Adjust your map extent and run the analysis again.",
    InvalidGeometryShapeForExpression:
        "The analysis uses the expression type, {0}. This type is not valid when analyzing a {1} shape with the selected Living Atlas layer's {2} shape. Select a valid expression or layer.",
    CannotSelectAllResults: "Cannot Select all Results",
    SpatialResultsSelectionExceeded:
        "More than {0} records are in the Spatial Analysis results. Only the first {0} of {1} records are selected. Filter the Layer or Add Expressions to decrease the results.",
    CannotRunAnalysis: "Cannot Run Analysis",
    RecordsInLayersChanged:
        "The records in the layers changed causing the layers to be stale. Click OK to refresh the page and start the command again.",
    ArcGISFeatureAccessBlocked:
        "Your access to this feature is blocked. Ask your GIS Administrator for help.",
    ConfigureAnalysis:
        "Your ArcGIS account is not configured to perform analysis. Ask your GIS Administrator for help.",
    NonPublicFacingURL:
        "One or more of the Esri layers selected in the query cannot be accessed. Ask your GIS Administrator for help.",
    InstalledAssets: "Installed Assets",
    CannotCompleteAnalysis: "Cannot Complete Spatial Analysis",
    SpatialAnalysisTimedOut:
        "There could be too many records to analyze or there is a problem connecting to the server. Filter out some records or turn off some active layers and try again.",
    //#endregion
    //#region Timeout
    YourSessionWillExpire: "Your session will expire in <b>{0} seconds</b>. Stay signed in?",
    SignOut: "Sign Out",
    StaySignedIn: "Stay Signed In",
    SessionExpiring: "Session Expiring",
    //#endregion
    //#region Dashboard
    GadgetLibrary: "Gadget Library",
    MaxGadgets: "Maximum number of gadgets on dashboard",
    MaxGadgetsHeadsUp: "Heads up! You've hit your limit of 20 gadgets.",
    MyLibraryInfo:
        "Sharing is caring! Add this gadget <br/> to your library to access it at any <br/> time or share it with others.",
    GadgetSaved: "Gadget Saved",
    //#endregion
    ResourceEstimatesManager: "Resource Estimates Manager",
    ResourceEstimatesSlideoutHeader: "{0} Custom Estimate",
    FieldSizeOptions: [
        {
            DisplayName: "Small",
            Value: 1
        },
        {
            DisplayName: "Medium",
            Value: 2
        },
        {
            DisplayName: "Large",
            Value: 3
        }
    ],

    DateFieldTypeOptions: [
        {
            DisplayName: "Date and Time",
            Value: 5
        },
        {
            DisplayName: "Date",
            Value: 11
        },
        {
            DisplayName: "Time",
            Value: 12
        }
    ],

    FieldTypeOptions: [
        {
            DisplayName: "Attachment",
            Value: 9
        },
        {
            DisplayName: "Check box",
            Value: 1
        },
        {
            DisplayName: "Currency",
            Value: 4
        },
        {
            DisplayName: "Date",
            Value: 11
        },
        {
            DisplayName: "Date and Time",
            Value: 5
        },
        {
            DisplayName: "Integer",
            Value: 2
        },
        {
            DisplayName: "Lookup",
            Value: 6
        },
        {
            DisplayName: "Number",
            Value: 3
        },
        {
            DisplayName: "Quantity",
            Value: 10
        },
        {
            DisplayName: "Text",
            Value: 0
        },
        {
            DisplayName: "Time",
            Value: 12
        }
    ],

    FieldTypeOptionsWOAttachment: [
        {
            DisplayName: "Check box",
            Value: 1
        },
        {
            DisplayName: "Currency",
            Value: 4
        },
        {
            DisplayName: "Date",
            Value: 11
        },
        {
            DisplayName: "Date and Time",
            Value: 5
        },
        {
            DisplayName: "Integer",
            Value: 2
        },
        {
            DisplayName: "Lookup",
            Value: 6
        },
        {
            DisplayName: "Number",
            Value: 3
        },
        {
            DisplayName: "Quantity",
            Value: 10
        },
        {
            DisplayName: "Text",
            Value: 0
        },
        {
            DisplayName: "Time",
            Value: 12
        }
    ],

    ImportExportTypeOptions: [
        {
            DisplayName: "Delimited text",
            Value: "delimited text"
        },
        {
            DisplayName: "ODBC",
            Value: "odbc"
        },
        {
            DisplayName: "Fixed width",
            Value: "fixed width"
        }
    ],

    ImportTextDelimiterOptions: [
        {
            DisplayName: "None",
            Value: "\0" // NUL character
        },
        {
            DisplayName: "\"",
            Value: "\""
        }
    ],

    ImportFieldDelimiterOptions: [
        {
            DisplayName: "Comma",
            Value: ","
        },
        {
            DisplayName: "Semicolon",
            Value: ";"
        },
        {
            DisplayName: "Tab",
            Value: "\t"
        }
    ],

    ImportTransactionScopeOptions: [
        {
            DisplayName: "Save records without errors",
            Value: "SingleRecord"
        },
        {
            DisplayName: "Log errors and roll back all records",
            Value: "AllRecords"
        }
    ],

    ImportOnDuplicateRecordOptions: [
        {
            DisplayName: "Overwrite the data",
            Value: "Overwrite"
        },
        {
            DisplayName: "Ignore the data source value",
            Value: "Ignore"
        }
    ],

    ImportOnNullValueOptions: [
        {
            DisplayName: "Only overwrite when the data source contains a value",
            Value: "Ignore"
        },
        {
            DisplayName: "Use all values from the data source including records without values",
            Value: "Overwrite"
        }
    ],

    ImportOnLongTextOptions: [
        {
            DisplayName: "Generate an import error",
            Value: "Error"
        },
        {
            DisplayName: "Automatically truncate the incoming text",
            Value: "Truncate"
        }
    ],

    ImportAutoAddLookupOptions: [
        {
            DisplayName: "Automatically add the value",
            Value: true
        },
        {
            DisplayName: "Do not add the value, log as an error",
            Value: false
        }
    ],

    ImportOnReadOnlyOptions: [
        {
            DisplayName: "Ignore data source value",
            Value: "Skip"
        },
        {
            DisplayName: "Generate an import error",
            Value: "Error"
        },
        {
            DisplayName: "Manual override",
            Value: "Overwrite",
            HideItem: true
        }
    ],

    ImportSpecialFunction: [
        {
            DisplayName: "Concatenate",
            Value: "Concatenate"
        },
        {
            DisplayName: "Custom Format",
            Value: null
        },
        {
            DisplayName: "Lookup",
            Value: "LookupValue"
        },
        {
            DisplayName: "",
            Value: "Standard",
            HideItem: true
        },
        {
            DisplayName: "Use Data Value",
            Value: ""
        }
    ],

    GisConfigurations: [
        {
            DisplayName: "Unsecured",
            Value: 0,
            HideItem: false
        },
        {
            DisplayName: "ArcGIS for Server credentials",
            Value: 1,
            HideItem: false
        },
        {
            DisplayName: "ArcGIS Online credentials",
            Value: 2,
            HideItem: false
        },
        {
            DisplayName: "Portal credentials",
            Value: 3,
            HideItem: false
        }
    ],

    ImpactUnits: ["Absolute", "%", "Relative"],
    MapSelectionToolUnits: [
        {
            DisplayName: "Miles",
            Value: "MILES"
        },
        {
            DisplayName: "Kilometers",
            Value: "KILOMETERS"
        },
        {
            DisplayName: "Feet",
            Value: "FEET"
        },
        {
            DisplayName: "Meters",
            Value: "METERS"
        },
        {
            DisplayName: "Yards",
            Value: "YARDS"
        },
        {
            DisplayName: "Nautical Miles",
            Value: "NAUTICAL_MILES"
        }
    ],
    AutomationTriggerEvents: [
        { DisplayName: "After Create", Value: 1 },
        { DisplayName: "After Fetch", Value: 2 },
        { DisplayName: "Before Insert", Value: 4 },
        { DisplayName: "Before Update", Value: 8 },
        { DisplayName: "Before Delete", Value: 16 },
        { DisplayName: "After Insert", Value: 32 },
        { DisplayName: "After Update", Value: 64 },
        { DisplayName: "After Delete", Value: 128 },
        { DisplayName: "Insert Committed", Value: 256 },
        { DisplayName: "Update Committed", Value: 512 },
        { DisplayName: "Delete Committed", Value: 1028 }
    ],
    MaintenanceModeWarningHeader: "Important Message",
    MaintenanceModeLockedHeader: "System Locked for Maintenance",
    MaintenanceModeLockedText:
        "While the system is locked for maintenance, users cannot sign into Cartegraph. After you make changes, make sure you set the System Status to Full Access so users can sign in.",
    MaintenanceModeAdminWarning:
        "While the system is locked for maintenance, users cannot sign into Cartegraph. After making changes, set the Status back to Full Access.",
    MaintenanceModeAdminWarningHeader: "Are you sure you want to lock  for maintenance?",
    SystemAccess: "Set System Access",
    MaintenanceLevels: [
        { Level: "0", DisplayName: "Full Access" },
        { Level: "1", DisplayName: "Notification" },
        { Level: "2", DisplayName: "Locked for Maintenance" }
    ],
    Copied: "Copied",
    DefaultRate: "Standard",
    ResourceModalTitle: "Enter Resource Values",
    CollapseAllSections: "Collapse All Sections",
    ExpandAllSections: "Expand All Sections",
    OCIRangeError: "OCI must be greater than or equal to 0 and no more than 100.",
    PlanYearSaved: "Plan Year Edits Saved",
    RecordHasBeenExcluded:
        "1 record has been excluded.\nSelect an Asset Type to see all records for that Asset Type.",
    RecordsHaveBeenExcluded:
        "{0} records have been excluded.\nSelect an Asset Type to see all records for that Asset Type.",
    SureDeleteCustomEstimate: "Are you sure you want to delete this custom estimate?",
    CartegraphEstimatesUsedInstead: "Cartegraph estimates will be used instead.",
    SetCustomEstimates: "Set Custom Estimates",
    SetCustomEstimatesWithQuantity: "Set Custom Estimates With a Quantity",
    UseCartegraphEstimates: "Use Cartegraph Calculated Estimates",
    EstimateOverridesLimitExceeded: (limit: number, total: number) =>
        `There are ${total} records. Only ${limit} records display in this list.\nSelect an Asset Type to filter the list.`,
    NoCustomEstimatesSet: "No Custom Estimates Set",
    EstimateOverrideWillBeDeleted: (asset: string, activity: string) =>
        `${asset}/${activity} does not have the minimum of one custom estimate required and will be deleted.`,
    NoDistributeCostQuantitySet: "No Distribute Cost Quantity Set",
    DistributedQuantityNotUsed: (asset: string) =>
        `${asset} does not have a Distribute Cost Using quantity set.  The estimated cost will be the value entered in the Cost field.<br /><br />If you want to use a calculation, go to the Library Manager and update the Distribute Cost Using field for the recordset.`,
    FEMAMultipleEffectiveDates:
        "Cannot create FEMA rates because the Effective Dates aren’t the same. Fix the dates to continue.",
    FEMABackDate: "Use the new FEMA rate and recalculate costs",
    FEMADontBackDate: "Keep the old FEMA rate and do not recalculate costs",
    FEMACostCodesRequired:
        "Cost codes are required to create rates. Import FEMA Cost Codes to continue.",
    FEMAUpdateRates: "Update FEMA Rates",
    FEMAUpdateRatesMsg: (effDate: string) =>
        `These equipment records have logs using the old FEMA rate after the new FEMA rate’s effective date of ${effDate}.<br/><br/>Select an option below to decide which FEMA rate to use on these logs.`,
    FEMAUnlinkedRates: "Unlinked Rates",
    FEMAInactiveCostCodes: "Inactive FEMA Cost Codes",
    FEMAInactiveCostCodesMsg:
        "Some equipment records are using inactive FEMA cost codes, and will not have a FEMA rate.",
    FEMARatesWillBeExpired:
        "Rates on these records will be expired if newer Equipment FEMA Rates exist. You can set the expiration date for the FEMA rate on the Equipment Detail View.<br /><br />No rates will be created because they are not linked to a FEMA Cost Code. Set a FEMA Cost Code on the Equipment records to make new rates.",
    MapAreaContinueUploadTitle: "Continue upload of {0} offline map?",
    MapAreaContinueUploadText: "Upload replaces the existing map and may take some time to complete.<br><br>After completion notify any CG1 users that a new map is available.",
    MapAreaUploadTitle: "Offline Map Upload",
    MapAreaCannotUploadMap: "Cannot upload Map",
    MapAreaArcGISLoginRequired: "To upload an offline map you must sign in with an ArcGIS Identity.",
    MapAreaUploaded: "A map was uploaded and is available for Cartegraph One.",
    _UNIT: "_unit",
    SignInAsUser: "Sign In as User",
    CannotSignIn: "Cannot Sign In",
    YourOwnAccount: "The selected user account is your own account. Select a different user account.",
    AlreadySignedIn: "The selected user account is already signed in as. Select a different user account.",
    AllAddressesAreValid: "All addresses are valid.",
    AddressesNotValid: "Some addresses are not formatted correctly.",
    MaxAddressesAllowed: (limit: number) => `A maximum of ${limit} external addresses are allowed.`,
    AddAddresses: "Add Addresses",
    ViewDuplicates: "View Duplicates",
    DuplicateResources: "Duplicate Resources",
    DuplicateResourcesFoud: "Potential Duplicate Resources Found",
    SaveDuplicateResources: "One or more tasks have a matching resource for the same date.  Would you like to save?",
    Reserved: "Reserved",
    MaterialPlanningBulkError: "Material Plan {0}: {1}",
    MaterialPlanningBulkStatusTitle: "Editing {0} Material Plan{1}",
    MaterialPlanningStatusUpdateErrorTitle: "Status Update Errors",
    MaterialPlansEditStatusErrorTitle: "Material Plans Edit Status Error",
    MaterialPlanningStatusStageError: (status: string) => `Could not resolve Stage for Status ${status}`,
    RecipientTabs: [
        {
            label: "Role/User",
            description: "Roles or Users",
            pendoId: "role-user-tab"
        },
        {
            label: "Email",
            description: "Email",
            pendoId: "text-tab"
        },
        {
            label: "Link to Field",
            description: "Link to Field",
            pendoId: "link-field-tab"
        },
        {
            label: "Syntax",
            description: "Syntax",
            pendoId: "syntax-tab"
        }
    ],
    SortOrderChoices: ["Ascending", "Descending"],
    InvalidAssetPrioErrorTitle: "The Asset Prioritization field requires a value.",
    InvalidAssetPrioErrorMsg: "Invalid Asset Prioritization",
};
